<template>
	<div :class="modalMode ? 'task-details-in-modal' : 'mb-5 mx-5 mt-3 ResponsiveControlePage'">
		<div class="mb-2" v-if="!modalMode">
			<breadCrumbs :routesArray="routesArray"></breadCrumbs>
		</div>
		<div class="items-center justify-between flex">
			<!-- <div v-if="!(presentSubTask.TaskName)" class="title flex items-center">
				<h1 :class="controltitle?.controlTitle != undefined && controltitle?.controlTitle.length > 40 ? 'heading-ellipsis':''">{{ controltitle?.controlTitle||'N/A' }}</h1>
				<h1 class="title">{{ controltitle.controlTitle }}</h1>
			</div> -->
			<div v-if="!modalMode" class="title flex items-center">
				  <h1 :class="presentSubTask.TaskName!=undefined && presentSubTask.TaskName!='' && presentSubTask.TaskName.length > 0 > 40? 'heading-ellipsis':''">{{ presentSubTask.TaskName }}</h1>
				<!-- <h1 class="title">{{ presentSubTask.TaskName }}</h1> -->
			</div>
			<div>
				
				<div v-if="checkOwner() && (presentSubTask.statusCode == 10421)" class="flex flex-row items-center">
					<!-- v-if="checkOwner() && presentSubTask.statusCode == 10402" -->
					<button class="btnprimary items-center mr-2" :disabled="clickOnButton" @click="approveOrRejectTheParentApproval(10403)">Approve</button>
					<button class="btnprimary items-center" :disabled="clickOnButton" @click="onClickToRejectByJustificationAtInReview()">Reject</button>
				</div>
				
				
			</div>
		</div>
		
		<div>
			<div class="w-full minheight">
				<div class="w-full">
					<div class="text-sm">
						<div class="mainContainer tabStructure flex flex-row w-full bg-white border rounded-sm mt-5 px-5 pt-5 pb-3 border-lightgrey">
							<Tabs  v-model:value="selectedTabIndex" scrollable class="w-80 heightFixing pr-5">
								<div>
									<TabList >
										<Tab  v-for="(tab, tabIndex) in tabHead" :key="tabIndex" :value="tab.id" @click="toggleTabs(tab)">
											{{ tab.displayName }}
										</Tab>
									</TabList>
								</div>
								<TabPanels class="overflow-auto hide-scrollbar">
									<TabPanel v-for="(tab,tabIndex) in tabHead" :key="tabIndex" :value="tab.id">
										<div v-if="dotsLoader == true">
											<div class="flex items-center justify-center w-full h-16 skeleton">
												<dotsloader/>
											</div>
										</div>
										<div v-else>
											<div class="overflow-y-scroll descriptionToggle" v-if="tab.id == 1 && (presentSubTask.appId!=10003 ||(presentSubTask.hasOwnProperty('control') && presentSubTask.treatmentType==10405))">
												<div class="flex">
													<div class="w-6/12">
														<p class="font-extrabold mt-3 mb-1 text-xs">CID</p>
														<p v-if="(linkedControlDetails[0]?.clientUniqueId||'N/A')" class="mt-1 mb-3 text-sm">{{ linkedControlDetails[0]?.clientUniqueId ||'N/A'}}</p>
														<p v-else class="text-sm mt-1 mb-3">N/A</p>
													</div>
													<div class="w-6/12">
														<p class="font-extrabold mt-3 mb-1 text-xs">Frequency</p>
														<p v-if="(presentSubTask?.controlFrequency||'N/A')" class="mt-1 mb-3 text-sm">{{getControlFrequency(presentSubTask?.controlFrequency)||'N/A'}}</p>
														<p class="text-sm mt-1 mb-3" v-else>N/A</p>
													</div>
													
												</div>

												<div class="flex">
													<div class="w-6/12">
														<p class="font-extrabold mb-1 text-xs">Title</p>
														<p v-if="(linkedControlDetails[0]?.controlTitle)" class="mt-1 text-sm">{{ linkedControlDetails[0]?.controlTitle||'N/A' }}</p>
														<p v-else class="text-sm mt-1">N/A</p>
													</div>
													<div class="w-6/12">
														<p class="font-extrabold mb-1 text-xs">Type</p>
														<p v-if="(linkedControlDetails[0]?.controlType)" class="mt-1 text-sm">{{ linkedControlDetails[0]?.controlType||'N/A' }}</p>
														<p v-else class="text-sm mt-1">N/A</p>
													</div>
												</div>
												<div class="flex flex-row mt-3"> 
													<div class="w-6/12">
														<label class="font-extrabold text-xs">Priority</label>
														<div v-if="linkedControlDetails[0]?.controlPriority && typeof linkedControlDetails[0]?.controlPriority === 'number'"	class="flex items-center justify-center rounded h-5 w-24 mt-2 mb-3" :class="colorLabelBg(linkedControlDetails[0]?.controlPriority)">
															<div class="text-xs" :class="colorLabelText(linkedControlDetails[0]?.controlPriority)">
															{{ getProirityLabel(linkedControlDetails[0]?.controlPriority) }}
															</div>
														</div>
														<div v-else class="text-sm mt-2">N/A</div>
													</div>
													
												</div> 
												<div class="flex">
													<div class="w-6/12">
														<p class="font-extrabold mt-2 mb-1 text-xs">Class</p>
														<p v-if="(linkedControlDetails[0]?.controlClass)" class="mt-1 mb-3 text-sm">{{ linkedControlDetails[0]?.controlClass||'N/A' }}</p>
														<p v-else class="text-sm mt-1 mb-3">N/A</p>
													</div>
													<div class="w-6/12">
														<p class="font-extrabold mt-2 mb-1 text-xs">Family</p>
														<p v-if="(linkedControlDetails[0]?.controlFamily)" class="mt-1 mb-3 text-sm">{{ linkedControlDetails[0]?.controlFamily||'N/A' }}</p>
														<p v-else class="text-sm mt-1 mb-3">N/A</p>
													</div>

												</div>
												<div> 
													<label class="font-extrabold mt-2 text-xs">Description</label>
													<p v-if="(linkedControlDetails[0]?.Description)" class="mt-1 mb-3 text-sm">{{ linkedControlDetails[0]?.Description||'N/A' }}</p>
													<p v-else class="text-sm mt-1 mb-3">N/A</p>
												</div>
												<div> 
													<label class="font-extrabold mt-2 text-xs">Policy/Procedure</label>
													<p v-if="(linkedControlDetails[0]?.controlPolicies)" class="mt-1 mb-3 text-sm">{{ linkedControlDetails[0]?.controlPolicies||'N/A' }}</p>
													<p v-else class="text-sm mt-1 mb-3">N/A</p>
												</div>
												<div>
													<label class="font-extrabold mt-2 mb-1 text-xs">Guidance</label>
													<p v-if="(linkedControlDetails[0]?.controlGuidance)" class="mt-1 mb-3 text-sm">{{ linkedControlDetails[0]?.controlGuidance||'N/A' }}</p>
													<p v-else class="text-sm mt-1 mb-3">N/A</p>
												</div>
												<div> 
													<label class="font-extrabold mt-2 mb-1  text-xs">Task</label>
													<p v-if="(linkedControlDetails[0]?.controlMaintenanceTask)" class="mt-1 mb-3 text-sm">{{ linkedControlDetails[0]?.controlMaintenanceTask||'N/A' }}</p>
													<p v-else class="text-sm mt-1 mb-3">N/A</p>
												</div>
												<!-- <div class="mb-2">
													{{ presentSubTask.description }}
												</div> -->
												<div v-if="presentSubTask.notes">
													<div>
															<p class="mt-2 mb-1 header">Notes</p>
														<p class="mt-1 mb-4">{{ presentSubTask.notes }}</p>
													</div>
													<!-- <div class="mb-2">
														{{ presentSubTask.notes }}
													</div> -->
												</div>
												<div v-if="presentSubTask.residual && presentSubTask.residual!=undefined && presentSubTask.residual!=''">
												<h1 class="upperspacing">Inherited Risk</h1>
												<!-- </div> -->
												<div class="border-b pt-1 border-solid border-lightgrey"></div>

												<div class="formcontainer flex flex-col upperspacing">
													<div class="row flex flex-row w-full">
														<div class="w-6/12">
															<label class="controllabel">Strategic</label>
															 <div class="flex items-center justify-center rounded h-5 w-24 mt-1" :class="colorRiskBg(presentSubTask.business)">
																<div :class="colorRiskText(presentSubTask.business)">
																	{{getLablesInfo(presentSubTask.business,1)||'N/A'}}
																</div>
															</div>
															
														</div>

														<div class="w-6/12 leftspacing">
															<label class="controllabel">Financial</label>
															 <div class="flex items-center justify-center rounded h-5 w-24 mt-1" :class="colorRiskBg(presentSubTask.financial)">
																<div :class="colorRiskText(presentSubTask.financial)">
																	{{getLablesInfo(presentSubTask.financial,2)||'N/A'}}
																</div>
															</div>
														</div>
													</div>
												</div>

												<div class="formcontainer flex flex-col upperspacing">
													<div class="row flex flex-row w-full">
														<div class="w-6/12">
															<label class="controllabel">Operations</label>
															<div class="flex items-center justify-center rounded h-5 w-24 mt-1" :class="colorRiskBg(presentSubTask.operations)">
																<div :class="colorRiskText(presentSubTask.operations)">
																	{{getLablesInfo(presentSubTask.operations,3)||'N/A'}}
																</div>
															</div>
														</div>

														<div class="w-6/12 leftspacing">
															<label class="controllabel">Compliance</label>
															<div class="flex items-center justify-center rounded h-5 w-24 mt-1" :class="colorRiskBg(presentSubTask.legal)">
																<div :class="colorRiskText(presentSubTask.legal)">
																	{{getLablesInfo(presentSubTask.legal,4)||'N/A'}}
																</div>
															</div>
														</div>
													</div>
												</div>
												<div class="formcontainer upperspacing">
													<div class="row flex flex-row w-full">
														<div class="w-3/6">
															<label class="controllabel">Likelihood</label>
															<div class="flex items-center justify-center rounded h-5 w-24 mt-1" :class="colorRiskBg(presentSubTask.likelihood)">
																<div :class="colorRiskText(presentSubTask.likelihood)">
																	{{getLablesInfo(presentSubTask.likelihood,5)||'N/A'}}
																</div>
															</div>
														</div>

														<div class="w-3/6 leftspacing">
															<label class="controllabel">Overall Impact</label>
															<div class="flex items-center justify-center rounded h-5 w-24 mt-1" :class="colorRiskBg(presentSubTask.overallImpact)">
																<div :class="colorRiskText(presentSubTask.overallImpact)">
																	{{getLablesInfo(presentSubTask.overallImpact,6)||'N/A'}}
																</div>
															</div>
														</div>
													</div>
												</div>
												
												<h1 class="upperspacing">Residual Risk</h1>
												<!-- </div> -->
												<div class="border-b pt-1 border-solid border-lightgrey"></div>

												<div class="formcontainer flex flex-col upperspacing">
													<div class="row flex flex-row w-full">
														<div class="w-6/12">
															<label class="controllabel">Strategic</label>
															<div class="flex items-center justify-center rounded h-5 w-24 mt-1" :class="colorRiskBg(presentSubTask?.residual?.business)">
																<div :class="colorRiskText(presentSubTask?.residual?.business)">
																	{{getLablesInfo(presentSubTask?.residual?.business,1)||'N/A'}}
																</div>
															</div>
														</div>

														<div class="w-6/12 leftspacing">
															<label class="controllabel">Financial</label>
															<div class="flex items-center justify-center rounded h-5 w-24 mt-1" :class="colorRiskBg(presentSubTask?.residual?.financial)">
																<div :class="colorRiskText(presentSubTask?.residual?.financial)">
																	{{getLablesInfo(presentSubTask?.residual?.financial,2)||'N/A'}}
																</div>
															</div>
														</div>
													</div>
												</div>

												<div class="formcontainer flex flex-col upperspacing">
													<div class="row flex flex-row w-full">
														<div class="w-6/12">
															<label class="controllabel">Operations</label>
															<div class="flex items-center justify-center rounded h-5 w-24 mt-1" :class="colorRiskBg(presentSubTask?.residual?.operations)">
																<div :class="colorRiskText(presentSubTask?.residual?.operations)">
																	{{getLablesInfo(presentSubTask?.residual?.operations,3)||'N/A'}}
																</div>
															</div>
														</div>

														<div class="w-6/12 leftspacing">
															<label class="controllabel">Compliance</label>
															<div class="flex items-center justify-center rounded h-5 w-24 mt-1" :class="colorRiskBg(presentSubTask?.residual?.legal)">
																<div :class="colorRiskText(presentSubTask?.residual?.legal)">
																	{{getLablesInfo(presentSubTask?.residual?.legal,4)||'N/A'}}
																</div>
															</div>
														</div>
													</div>
												</div>
												<div class="formcontainer upperspacing">
													<div class="row flex flex-row w-full">
														<div class="w-3/6">
															<label class="controllabel">Likelihood</label>
															<div class="flex items-center justify-center rounded h-5 w-24 mt-1" :class="colorRiskBg(presentSubTask?.residual?.likelihood)">
																<div :class="colorRiskText(presentSubTask?.residual.likelihood)">
																	{{getLablesInfo(presentSubTask?.residual?.likelihood,5)||'N/A'}}
																</div>
															</div>
														</div>

														<div class="w-3/6 leftspacing">
                                                            <label class="controllabel">Overall Impact</label>
                                                            <div class="flex items-center justify-center rounded h-5 w-24 mt-1" :class="colorRiskBg(presentSubTask.overallImpact)">
                                                                <div :class="colorRiskText(presentSubTask.overallImpact)">
                                                                    {{getLablesInfo(presentSubTask.overallImpact,6)||'N/A'}}
                                                                </div>
                                                            </div>
                                                        </div>
													</div>
												</div>
												</div>
											</div>
											<div class="overflow-y-scroll descriptionToggle" v-if="tab.id == 1 && presentSubTask.appId==10003 && !presentSubTask.hasOwnProperty('control')">
												<div>
													<div>
													<div class="border-b border-lightgrey">
														<p class="mt-3 mb-1.5 header">Risk Info</p>
													</div>
													</div>
												<div class="flex mb-1">
													<div class="w-6/12">
														<p class="font-extrabold mt-3 mb-1 text-xs">Risk</p>
														<p v-if="(presentSubTask.TaskName||'N/A')" class="mt-1 text-sm">{{ presentSubTask.TaskName ||'N/A'}}</p>
														<p v-else class="text-sm mt-1">N/A</p>
													</div>
													<div class="w-6/12">
														<p class="font-extrabold mt-3 mb-1 text-xs">Priority</p>
														<div v-if="presentSubTask.priority && typeof presentSubTask.priority === 'number'"	class="flex items-center justify-center rounded h-5 w-24 mt-2 mb-3" :class="colorLabelBg(presentSubTask.riskInformation.priority)">
															<div class="text-xs" :class="colorLabelText(presentSubTask.priority)">
															{{ getProirityLabel(presentSubTask.priority) }}
															</div>
														</div>
														<div v-else class="text-sm mt-2">N/A</div>

													</div>
													
												</div>

												<div class="flex mb-1">
													<!-- <div class="w-6/12">
														<p class="font-extrabold mb-1 text-xs">Action</p>
														<p v-if="(presentSubTask.riskInformation.action)" class="mt-1 text-sm">{{presentSubTask.riskInformation.action||'N/A' }}</p>
														<p v-else class="text-sm mt-1">N/A</p>
													</div> -->
													<div class="w-6/12">
														<p class="font-extrabold mb-1 text-xs">Risk Category</p>
														<p v-if="(presentSubTask.riskCategory)" class="mt-1 text-sm">{{ presentSubTask.riskCategory||'N/A' }}</p>
														<p v-else class="text-sm mt-1">N/A</p>
													</div>
													<div class="w-6/12">
														<p class="font-extrabold mb-1 text-xs">Risk Owner</p>
														<p v-if="(presentSubTask.riskOwner)" class="mt-1 text-sm">{{ getRiskOwnerLabel(presentSubTask.riskOwner)||'N/A' }}</p>
														<p v-else class="text-sm mt-1">N/A</p>
													</div>
													
												</div>
												<div class="flex mb-1">
													<div class="w-6/12">
														<p class="font-extrabold mt-2 mb-1 text-xs">Threat Category</p>
														<p v-if="(presentSubTask.threatCategory)" class="mt-1 mb-3 text-sm">{{ presentSubTask.threatCategory||'N/A' }}</p>
														<p v-else class="text-sm mt-1 mb-3">N/A</p>
													</div>
													<div class="w-6/12"> 
														<label class="font-extrabold mt-2 text-xs">Threat Source</label>
														<p v-if="(presentSubTask.threatSource)" class="mt-1 mb-3 text-sm">{{ presentSubTask.threatSource||'N/A' }}</p>
														<p v-else class="text-sm mt-1 mb-3">N/A</p>
													</div>
													

												</div>
												<div class="w-full">
														<p class="font-extrabold mt-2 mb-1 text-xs">Threat</p>
														<p v-if="(presentSubTask.threatEvent)" class="mt-1 mb-3 text-sm">{{ presentSubTask.threatEvent||'N/A' }}</p>
														<p v-else class="text-sm mt-1 mb-3">N/A</p>
													</div>
												<div class="w-full"> 
													<label class="font-extrabold mt-2 text-xs">Vulnerability</label>
													<p v-if="(presentSubTask.vulnerability)" class="mt-1 mb-3 text-sm">{{ presentSubTask.vulnerability||'N/A' }}</p>
													<p v-else class="text-sm mt-1 mb-3">N/A</p>
												</div>
												<div class="w-full">
													<p class="font-extrabold mb-2 text-xs">Risk Assessment</p>
													<p v-if="(presentSubTask.riskAssessment!='')" class="mt-1 mb-3 text-sm">{{ presentSubTask.riskAssessment||'N/A' }}</p>
													<p v-else class="text-sm mt-1 mb-3">N/A</p>
												</div>
												<div class="w-full">
													<p class="font-extrabold mb-2 text-xs">Treatment Summary</p>
													<p v-if="(presentSubTask.treatmentType!='')" class="mt-1 text-sm">{{ treatmentSummaryData(presentSubTask.treatmentType)||'N/A' }}</p>
													<p v-else class="text-sm mt-1">N/A</p>
												</div>
												</div>
												<div>
												<h1 class="upperspacing">Inherited Risk</h1>
												<!-- </div> -->
												<div class="border-b pt-1 border-solid border-lightgrey"></div>

												<div class="formcontainer flex flex-col upperspacing">
													<div class="row flex flex-row w-full">
														<div class="w-6/12">
															<label class="controllabel">Strategic</label>
															 <div class="flex items-center justify-center rounded h-5 w-24 mt-1" :class="colorRiskBg(presentSubTask.business)">
																<div :class="colorRiskText(presentSubTask.business)">
																	{{getLablesInfo(presentSubTask.business,1)||'N/A'}}
																</div>
															</div>
															
														</div>

														<div class="w-6/12 leftspacing">
															<label class="controllabel">Financial</label>
															 <div class="flex items-center justify-center rounded h-5 w-24 mt-1" :class="colorRiskBg(presentSubTask.financial)">
																<div :class="colorRiskText(presentSubTask.financial)">
																	{{getLablesInfo(presentSubTask.financial,2)||'N/A'}}
																</div>
															</div>
														</div>
													</div>
												</div>

												<div class="formcontainer flex flex-col upperspacing">
													<div class="row flex flex-row w-full">
														<div class="w-6/12">
															<label class="controllabel">Operations</label>
															<div class="flex items-center justify-center rounded h-5 w-24 mt-1" :class="colorRiskBg(presentSubTask.operations)">
																<div :class="colorRiskText(presentSubTask.operations)">
																	{{getLablesInfo(presentSubTask.operations,3)||'N/A'}}
																</div>
															</div>
														</div>

														<div class="w-6/12 leftspacing">
															<label class="controllabel">Compliance</label>
															<div class="flex items-center justify-center rounded h-5 w-24 mt-1" :class="colorRiskBg(presentSubTask.legal)">
																<div :class="colorRiskText(presentSubTask.legal)">
																	{{getLablesInfo(presentSubTask.legal,4)||'N/A'}}
																</div>
															</div>
														</div>
													</div>
												</div>
												<div class="formcontainer upperspacing">
													<div class="row flex flex-row w-full">
														<div class="w-3/6">
															<label class="controllabel">Likelihood</label>
															<div class="flex items-center justify-center rounded h-5 w-24 mt-1" :class="colorRiskBg(presentSubTask.likelihood)">
																<div :class="colorRiskText(presentSubTask.likelihood)">
																	{{getLablesInfo(presentSubTask.likelihood,5)||'N/A'}}
																</div>
															</div>
														</div>

														<div class="w-3/6 leftspacing">
															<label class="controllabel">Overall Impact</label>
															<div class="flex items-center justify-center rounded h-5 w-24 mt-1" :class="colorRiskBg(presentSubTask.overallImpact)">
																<div :class="colorRiskText(presentSubTask.overallImpact)">
																	{{getLablesInfo(presentSubTask.overallImpact,6)||'N/A'}}
																</div>
															</div>
														</div>
													</div>
												</div>
												</div>
												<div v-if="presentSubTask.treatmentType && presentSubTask.treatmentType!=10419 && presentSubTask.residualRisk?.length">
													<h1 class="upperspacing">Residual Risk</h1>
												<!-- </div> -->
												<div class="border-b pt-1 border-solid border-lightgrey"></div>

												<div class="formcontainer flex flex-col upperspacing">
													<div class="row flex flex-row w-full">
														<div class="w-6/12">
															<label class="controllabel">Strategic</label>
															<div class="flex items-center justify-center rounded h-5 w-24 mt-1" :class="colorRiskBg(presentSubTask.residualRisk?.[0]?.business)">
																<div :class="colorRiskText(presentSubTask.residualRisk?.[0]?.business)">
																	{{getLablesInfo(presentSubTask.residualRisk?.[0]?.business,1)||'N/A'}}
																</div>
															</div>
														</div>

														<div class="w-6/12 leftspacing">
															<label class="controllabel">Financial</label>
															<div class="flex items-center justify-center rounded h-5 w-24 mt-1" :class="colorRiskBg(presentSubTask.residualRisk?.[0]?.financial)">
																<div :class="colorRiskText(presentSubTask.residualRisk?.[0]?.financial)">
																	{{getLablesInfo(presentSubTask.residualRisk?.[0]?.financial,2)||'N/A'}}
																</div>
															</div>
														</div>
													</div>
												</div>

												<div class="formcontainer flex flex-col upperspacing">
													<div class="row flex flex-row w-full">
														<div class="w-6/12">
															<label class="controllabel">Operations</label>
															<div class="flex items-center justify-center rounded h-5 w-24 mt-1" :class="colorRiskBg(presentSubTask.residualRisk?.[0]?.operations)">
																<div :class="colorRiskText(presentSubTask.residualRisk?.[0]?.operations)">
																	{{getLablesInfo(presentSubTask.residualRisk?.[0]?.operations,3)||'N/A'}}
																</div>
															</div>
														</div>

														<div class="w-6/12 leftspacing">
															<label class="controllabel">Compliance</label>
															<div class="flex items-center justify-center rounded h-5 w-24 mt-1" :class="colorRiskBg(presentSubTask.residualRisk?.[0]?.legal)">
																<div :class="colorRiskText(presentSubTask.residualRisk?.[0]?.legal)">
																	{{getLablesInfo(presentSubTask.residualRisk?.[0]?.legal,4)||'N/A'}}
																</div>
															</div>
														</div>
													</div>
												</div>
												<div class="formcontainer upperspacing">
													<div class="row flex flex-row w-full">
														<div class="w-3/6">
															<label class="controllabel">Likelihood</label>
															<div class="flex items-center justify-center rounded h-5 w-24 mt-1" :class="colorRiskBg(presentSubTask.residualRisk?.[0]?.likelihood)">
																<div :class="colorRiskText(presentSubTask.residualRisk?.[0]?.likelihood)">
																	{{getLablesInfo(presentSubTask.residualRisk?.[0]?.likelihood,5)||'N/A'}}
																</div>
															</div>
														</div>

														<div class="w-3/6 leftspacing">
                                                            <label class="controllabel">Overall Impact</label>
                                                            <div class="flex items-center justify-center rounded h-5 w-24 mt-1" :class="colorRiskBg(presentSubTask.riskInformation.overallImpact)">
                                                                <div :class="colorRiskText(presentSubTask.riskInformation.overallImpact)">
                                                                    {{getLablesInfo(presentSubTask.riskInformation.overallImpact,6)||'N/A'}}
                                                                </div>
                                                            </div>
                                                        </div>
													</div>
												</div>
												</div>
												
												
											</div>
											<div class="overflow-y-scroll descriptionToggle" v-if="tab.id == 2">
												<div>
													<div class="border-b border-lightgrey flex justify-between">
														<!-- <div class="flex items-center mt-0.5 marginTopForDoc marginBottomForDoc justify-center"> -->
															<div>
																<p class="my-2 header">Documents</p>
															</div>
														<!-- </div> -->
														<div class="buttonposition flex justify-center items-center mb-1.5">
															<!-- <button class=" btnprimary flex justify-center taskEditButtons">Attach</button> -->
														</div>
													</div>
													
												</div>
											</div>
											<div class="overflow-y-scroll descriptionToggle evidence-description" v-if="tab.id == 3">
												<div class="evidence-tab-content">
													<div class="evidence-files-block">
													<div class="border-b border-lightgrey flex justify-between">
														<div class="flex items-center justify-center">
															<p class="my-1 header">Files</p>
														</div>
														<div class="buttonposition flex justify-center items-center sendapprovalheight gap-2">
															<button
																@click="openLinkEvidencePopup"
																:class="isEvidenceAttachDisabled ? 'btndisabled pointer-events-none paddingForAttachButton' : 'btnprimary flex justify-center taskEditButtons'"
															>Link Existing</button>
															<button
																@click="openFilePopup('file')"
																:class="isEvidenceAttachDisabled ? 'btndisabled pointer-events-none paddingForAttachButton' : 'btnprimary flex justify-center taskEditButtons'"
															>Attach</button>
														</div>
													</div>
													<div class="evidence-files-section">
														<div v-if="fileEvidences.length" class="flex mt-4 gap-4 flex-wrap">
															<div v-for="(doc, idx) in fileEvidences" :key="'file-'+idx">
																<div class="pdf">
																	<a
																		href="#"
																		@click.prevent="openEvidenceFile(doc)"
																		class="evidence-file-main"
																	>
																		<img src="@/assets/pdf.svg" alt="" v-if=" getEvidenceFileExt(doc)=='pdf'" />
																		<img src="@/assets/doc.svg" alt="" v-if=" getEvidenceFileExt(doc)=='doc'"/>
																		<img src="@/assets/docx.svg" alt="" v-if=" getEvidenceFileExt(doc)=='docx'" />
																		<img src="@/assets/xls.svg" alt="" v-if=" getEvidenceFileExt(doc)=='xls'" />
																		<img src="@/assets/xlsx.svg" alt="" v-if=" getEvidenceFileExt(doc)=='xlsx'" />
																		<img src="@/assets/pdf.svg" alt="" v-if=" getEvidenceFileExt(doc)=='rtf'"/>
																		<img src="@/assets/txt.svg" alt="" v-if=" getEvidenceFileExt(doc)=='txt'"/>
																		<img src="@/assets/png.svg" alt="" v-if=" getEvidenceFileExt(doc)=='png'"/>
																		<img src="@/assets/jpg.svg" alt="" v-if=" getEvidenceFileExt(doc)=='jpg'"/>
																		<img src="@/assets/jpeg.svg" alt="" v-if=" getEvidenceFileExt(doc)=='jpeg'"/>
																		<img src="@/assets/csv.svg" alt="" v-if=" getEvidenceFileExt(doc)=='csv'"/>
																		<img src="@/assets/zip.svg" alt="" v-if=" getEvidenceFileExt(doc)=='zip'"/>
																		<img src="@/assets/mp4.svg" alt="" v-if=" getEvidenceFileExt(doc)=='mp4'"/>
																		<div class="evidence-file-text">
																			<div class="evidence-file-top">
																				<p class="evidence-file-name" :title="doc.filename || doc.name">{{ doc.filename || doc.name || 'N/A' }}</p>
																				<button type="button" class="evidence-file-delete" @click.stop.prevent="openDeleteEvidenceConfirm(presentSubTask.evidences.indexOf(doc))" :class="isEvidenceAttachDisabled ? 'pointer-events-none' : ''">
																					<img src="@/assets/deleteIcon.svg" alt="Delete" />
																				</button>
																			</div>
																			<div class="evidence-file-meta">
																				<p class="evidence-file-date">{{ doc.evidenceDate ? formatFileAttachedTime(doc.evidenceDate) : 'N/A' }}</p>
																				<p class="evidence-file-task" :title="doc.taskId || 'N/A'">{{ doc.taskId || 'N/A' }}</p>
																			</div>
																		</div>
																	</a>
																</div>
															</div>
														</div>
														<p v-else class="text-xs text-placeholdergray mt-3">No files attached</p>
													</div>
													</div>

													<div class="evidence-links-section">
													<div class="border-b border-lightgrey flex justify-between mt-6">
														<div class="flex items-center justify-center">
															<p class="my-1 header">Links</p>
														</div>
														<div class="buttonposition flex justify-center items-center sendapprovalheight gap-2">
															<button
																@click="openFilePopup('url')"
																:class="isEvidenceAttachDisabled ? 'btndisabled pointer-events-none paddingForAttachButton' : 'btnprimary flex justify-center taskEditButtons'"
															>Add Link</button>
														</div>
													</div>
													<div class="evidence-links-wrap" :class="{ 'evidence-links-wrap--empty': filteredLinkCount === 0 }">
														<div class="evidence-links-scroll">
															<div class="evidence-links-header">
																<table class="evidence-links-table" :style="linkTableResizeStyle">
																	<thead>
																		<tr>
																			<th class="cursor-pointer evidence-links-col-title resizable-th" :style="linkColumnStyle('filename')" @click="onLinkHeaderClick('filename')">
																				<div class="flex items-center">
																					<div>Link Title</div>
																					<div class="sort cursor-pointer" :class="linkSortKey === 'filename' ? linkSortClass : 'opacity-50'"></div>
																				</div>
																				<span class="column-resize-handle" @mousedown.stop.prevent="startLinkColumnResize($event, 'filename')"></span>
																			</th>
																			<th class="cursor-pointer evidence-links-col-link resizable-th" :style="linkColumnStyle('url')" @click="onLinkHeaderClick('url')">
																				<div class="flex items-center">
																					<div>Link</div>
																					<div class="sort cursor-pointer" :class="linkSortKey === 'url' ? linkSortClass : 'opacity-50'"></div>
																				</div>
																				<span class="column-resize-handle" @mousedown.stop.prevent="startLinkColumnResize($event, 'url')"></span>
																			</th>
																			<th class="cursor-pointer evidence-links-col-date resizable-th" :style="linkColumnStyle('evidenceDate')" @click="onLinkHeaderClick('evidenceDate')">
																				<div class="flex items-center">
																					<div>Evidence Date</div>
																					<div class="sort cursor-pointer" :class="linkSortKey === 'evidenceDate' ? linkSortClass : 'opacity-50'"></div>
																				</div>
																				<span class="column-resize-handle" @mousedown.stop.prevent="startLinkColumnResize($event, 'evidenceDate')"></span>
																			</th>
																			<th class="evidence-links-col-action"></th>
																		</tr>
																	</thead>
																</table>
															</div>
															<div class="evidence-links-body">
																<table class="evidence-links-table" :style="linkTableResizeStyle">
																	<tbody v-if="paginatedLinkEvidences.length">
																		<tr
																			v-for="(doc, idx) in paginatedLinkEvidences"
																			:key="'link-'+idx"
																			class="rowHeight evidence-links-row"
																		>
																			<td class="evidence-links-col-title" :style="linkColumnStyle('filename')" :title="doc.filename || doc.name">
																				<div class="table-ellipsis">{{ doc.filename || doc.name || 'N/A' }}</div>
																			</td>
																			<td class="evidence-links-col-link" :style="linkColumnStyle('url')">
																				<div class="table-ellipsis">
																					<a href="#" class="text-primary evidence-link-anchor cursor-pointer" @click.prevent="openEvidenceFile(doc)" :title="doc.url">{{ doc.url }}</a>
																				</div>
																			</td>
																			<td class="evidence-links-col-date" :style="linkColumnStyle('evidenceDate')">{{ doc.evidenceDate ? formatFileAttachedTime(doc.evidenceDate) : 'N/A' }}</td>
																			<td class="evidence-links-col-action">
																				<button type="button" class="evidence-links-delete" @click.stop.prevent="openDeleteEvidenceConfirm(presentSubTask.evidences.indexOf(doc))" :class="isEvidenceAttachDisabled ? 'pointer-events-none' : ''">
																					<img src="@/assets/deleteIcon.svg" alt="Delete" class="h-5 w-5" />
																				</button>
																			</td>
																		</tr>
																	</tbody>
																	<tbody v-else>
																		<tr>
																			<td class="evidence-links-empty" colspan="4">
																				<div class="flex justify-center"><p class="text-xs font-normal">No Records Found</p></div>
																			</td>
																		</tr>
																	</tbody>
																</table>
															</div>
														</div>
														<pagination
															v-if="filteredLinkCount > 0"
															:dynamicPagination="filteredLinkCount"
															:sortedData="sortedLinkEvidences"
															@currentPageUpdate="onLinkPaginationUpdate"
														/>
													</div>
													</div>
												</div>
											</div>
											<div class="overflow-y-scroll descriptionToggle" v-if="tab.id == 5">
												<div>
													<div class="border-b border-lightgrey flex justify-between">
														<div class="flex items-center justify-center">
															<div>
																<p class="my-2.5 header">Comments</p>
															</div>
														</div>
														<div>
															<div class="buttonposition flex justify-center items-center sendapprovalheight">
																<!-- <div class="buttonposition flex justify-center items-center"> -->
																	<button class="btnprimary flex taskEditButtons" v-if="!oldComments" @click="sortComments()">
																		<img src="@/assets/sortBy.svg" class="h-3 mr-2" />
																		Newest
																	</button>
																	<button class="btnprimary flex taskEditButtons" v-if="oldComments" @click="sortComments()">
																		<img src="@/assets/sortBy.svg" class="h-3 mr-2 rotate-180" />
																		Oldest
																	</button>
																<!-- </div> -->
															</div>
														</div>
													</div>
													<div>
														<div class="comment-box w-full">
															<!-- <div class="my-3"><textarea placeholder="Add a Comment" class="w-full text-xs border border-lightgrey rounded-sm p-2" rows="4" :disabled="presentSubTask.statusCode == 10403"  v-model="comment" @input="handleInput"></textarea></div>
															<div class="flex justify-end">
																<button @click="addComment" class="mr-2" :class="{ btnprimary: !btnDisabled, btndisabled: btnDisabled }" :disabled="btnDisabled">Add</button>
																<button @click="clearComment" :class="{ btnprimary: !btnDisabled, btndisabled: btnDisabled }" :disabled="btnDisabled">Cancel</button>
															</div> -->
															<div class="my-3">
																<commentsEditor v-if="TaskDetailsDropDown.taskStatus!=10403&&TaskDetailsDropDown.taskStatus!=10401&&TaskDetailsDropDown.taskStatus!=10420 && TaskDetailsDropDown.taskStatus!=10423 && TaskDetailsDropDown.taskStatus!=10410 &&presentSubTask.statusCode != 10418&& !isAddDisabled(10302)"/>
															</div>
															
														</div>
														<div v-if="Object.keys(presentSubTask).includes('comments')" class="comments">
															<div v-for="(obj, index) in presentSubTask.comments" class="border border-lightgrey mt-2 rounded-sm flex flex-row p-2" :key="index">
																<div class="initials">{{extractInitials((obj.name) )}}</div>
																<div class="w-1/5">
																	<div class="header">{{(obj.name) }}</div>
																	<div class="fontSize10PX">{{formatTime( obj.createdAt )}}</div>
																</div>
																<div class="w-4/5 text-xs"><safeHtml :content="obj.comment"/></div>
															</div>
														</div>
													</div>
												</div>
											</div>
											<div class="overflow-y-scroll descriptionToggle" v-if="tab.id == 4">
												<div class="border-b border-lightgrey flex justify-between">
													<div class="flex items-center justify-center">
														<div>
															<p class="header">Approvals</p>
														</div>
													</div>
													<div>
														<div
														class="buttonposition flex justify-center items-center sendapprovalheight"
														>
															<div
																class="buttonposition flex justify-center items-center"
															>
																<button @click="openApprovalpopup()" :class="presentSubTask.statusCode==10403 || presentSubTask.statusCode==10421 || presentSubTask.statusCode==10420||presentSubTask.statusCode==10423||presentSubTask.statusCode==10410|| presentSubTask.statusCode == 10418|| isAddApprovalDisabled(10302)?'approvalbtndisabled pointer-events-none paddingForAttachButton' : 'btnprimary flex justify-center taskEditButtons'" >
																Send Approval
																</button>
															</div>
														</div>
													</div>
												</div>
												<div>
													<div v-for="(approval, number) in presentSubTask.approvals" :key="number" class="bg-white flex flex-row p-4 mb-0.5 border-lightgrey border-b w-full">
														<div v-if="approval.createdBy != undefined && !approval.updatedBy" class="initials">{{extractInitials((approval.name))}}</div>
														<div v-if="approval.createdBy != undefined && !approval.updatedBy" class="font-semibold mt-1 text-xs">{{ (approval.name) }}</div>
														
														<div v-if="approval.updatedBy != undefined" class="initials">{{extractInitials((approval.name))}}</div>
														<div v-if="approval.updatedBy != undefined" class="font-semibold mt-1 text-xs">{{ (approval.name) }}</div>

														<div v-if="approval.statusCode == 10401" class="mx-2 mt-1 text-xs"> {{' Requested an approval '}} </div>
														<div v-else-if="approval.statusCode == 10410" class="mx-2 mt-1 text-xs"> {{' Rejected an approval '}} </div>
														<div v-else-if="approval.statusCode == 10403" class="mx-2 mt-1 text-xs"> {{' Approved an approval '}} </div>
														<div v-if="approval.createdAt != undefined" class="font-semibold mt-1 text-xs">{{formatTime(approval.createdAt)}}</div>
														<div v-if="approval.updatedAt != undefined" class="font-semibold mt-1 text-xs">{{formatTime(approval.updatedAt)}}</div>
													</div>
												</div>
											</div>
											<div class="overflow-y-scroll descriptionToggle" v-if="tab.id == 6">
												<div>
													<div class="border-b border-lightgrey flex justify-between">
														<div class="flex items-center justify-between">
															<div>
																<p class="header">History</p>
															</div>
														</div>
														<div>
															<div class="buttonposition flex justify-center items-center sendapprovalheight">
																<div class="buttonposition flex justify-center items-center">
																	<button class="btnprimary flex taskEditButtons" v-if="!newHistory" @click="sortWorkLog()">
																		<img src="@/assets/sortBy.svg" class="h-3 mr-2" />
																		Newest
																	</button>
																	<button class="btnprimary flex taskEditButtons" v-if="newHistory" @click="sortWorkLog()">
																		<img src="@/assets/sortBy.svg" class="h-3 mr-2 rotate-180" />
																		Oldest
																	</button>
																</div>
															</div>
														</div>
													</div>

												<div v-for="(work, historyIndex) in workLogObject.taskHistory" :key="historyIndex + '-' + (work.updatedAt || work.createdAt || '')" class="bg-white p-4 mb-0.5 border-lightgrey border-b w-full">
														<div class="flex">
															<div v-if="Object.keys(work).includes('createdBy')" class="initials">
																{{ extractInitials((work.name)) }}
															</div>
															<div v-if="Object.keys(work).includes('updatedBy')" class="initials">
																{{ extractInitials((work.name)) }}
															</div>
															<!-- <div class="flex ml-4" v-if="Object.keys(work).includes('previousStatus')">
																
																<div class="">
																	
																	<div class="flex mt-3">
																		<div class="flex items-center justify-center rounded h-5 labelWidth" :class="colorTemplateBg(work.previousStatus)">
																			<div :class="colorTemplateText(work.previousStatus)">
																				{{ getStatusLabel(work.previousStatus) }}
																			</div>
																		</div>
																		<div class="mx-4 flex items-center w-3.5"><img src="@/assets/arrowRight.svg"/></div>
																		<div class="flex items-center justify-center rounded h-5 labelWidth" :class="colorTemplateBg(work.updatedStatus)">
																			<div :class="colorTemplateText(work.updatedStatus)">
																				{{ getStatusLabel(work.updatedStatus) }}
																			</div>
																		</div>
																	</div>
																</div>
															</div> -->
															<div class="logContainer w-93">
																<div class="flex mt-1">
																	<p v-if="Object.keys(work).includes('createdBy')" class="font-semibold text-xs">
																		{{ (work.name) }}
																	</p>
																	<p v-else-if="Object.keys(work).includes('updatedBy')" class="font-semibold text-xs">
																		{{ (work.name) }}
																	</p>
			
																	<p v-if="work.actionEntity == 10301" class="mx-2 text-xs">{{ 'Created the Task on' }}</p>
																	<p v-else-if="work.statusCode != undefined && work.statusCode == 10418" class="mx-2 text-xs">{{ 'Terminated the Task on' }}</p>
																	<p v-else-if="work.actionEntity == 10302" class="mx-2 text-xs">{{ 'Updated the Task on' }}</p>
			
																	<p v-if="Object.keys(work).includes('createdAt')" class="font-semibold  text-xs">{{ formatTime(work.createdAt) }}</p>
																	<p v-if="Object.keys(work).includes('updatedAt')" class="font-semibold text-xs">{{ formatTime(work.updatedAt) }}</p>
																</div>
																
																<div class="mt-3" v-if="Object.keys(work).includes('additionalInfo')">
																	<div class="flex" v-if="Object.keys(work.additionalInfo).includes('comment')">
																		<p class="font-semibold text-xs widthForCommentBox">{{ 'Comment :' }}</p>
																		<p class="text-xs w-full text-justify"><safeHtml :content="work.additionalInfo.comment"/></p>
																	</div>
																	<div class="flex" v-if="Object.keys(work.additionalInfo).includes('dateId')">
																		<p class="font-normal text-xs">{{'Updated the '}}</p>
																		<p v-if="work.additionalInfo.dateId==20606" class="font-normal text-xs ml-2">{{' Completion Date from'}}</p>
																				<p v-else-if="work.additionalInfo.dateId==20604" class="font-normal text-xs ml-2">{{' Start Date from'}}</p>
																					<p v-else-if="work.additionalInfo.dateId==20605" class="font-normal text-xs ml-2">{{' dueDate from'}}</p>
																				<p v-if="work.additionalInfo.previousCompletionDate!='' && work.additionalInfo.dateId==20606" class="font-semibold text-xs ml-2">{{formatDate(work.additionalInfo?.previousCompletionDate)}}</p>
																				<p v-else-if="work.additionalInfo.previousStartDate!='' && work.additionalInfo.dateId==20604" class="font-semibold text-xs ml-2">{{formatDate(work.additionalInfo?.previousStartDate)}}</p>
																				<p v-else-if="work.additionalInfo.previousEndDate!='' && work.additionalInfo.dateId==20605" class="font-semibold text-xs ml-2">{{formatDate(work.additionalInfo?.previousEndDate)}}</p>
																				<p v-else  class="font-semibold text-xs ml-2">N/A</p>
																				<p class="mx-2 font-normal text-xs">{{ 'to' }}</p>
																				
																				<p v-if="work.additionalInfo.updatedCompletionDate!=''&& work.additionalInfo.dateId==20606" class="font-semibold text-xs">{{formatDate(work.additionalInfo.updatedCompletionDate) }}</p>
																				<p v-else-if="work.additionalInfo.updatedStartDate!=''&& work.additionalInfo.dateId==20604" class="font-semibold text-xs ml-2">{{formatDate(work.additionalInfo?.updatedStartDate)}}</p>
																				<p v-else-if="work.additionalInfo.updatedEndDate!='' && work.additionalInfo.dateId==20605" class="font-semibold text-xs ml-2">{{formatDate(work.additionalInfo?.updatedEndDate)}}</p>
																				<p v-else class="font-semibold text-xs">N/A</p>
																	</div>
																	
																	<div class="flex" v-if="Object.keys(work.additionalInfo).includes('linkedEvidenceTitles') || Object.keys(work.additionalInfo).includes('linkedEvidenceTaskIds')">
																		<p class="font-semibold text-xs">{{ 'Linked the Evidence -' }}</p>
																		<p class="mx-2 text-xs">{{ work.additionalInfo.linkedEvidenceTitles || work.additionalInfo.linkedEvidenceTaskIds }}</p>
																	</div>
																	<div class="flex mt-2" v-if="Object.keys(work.additionalInfo).includes('linkedEvidenceDates')">
																		<p class="font-semibold text-xs">{{'Evidence Date -'}}</p>
																		<p class="mx-2 text-xs">{{ work.additionalInfo.linkedEvidenceDates || 'N/A' }}</p>
																	</div>
																	<div class="flex" v-if="Object.keys(work.additionalInfo).includes('filename')">
																		<p class="font-semibold text-xs">{{ work.additionalInfo.removed ? 'Deleted the Evidence -' : 'Uploaded the Evidence -' }}</p>
																		<p class="mx-2 text-xs">{{ work.additionalInfo.filename }}</p>
																	</div>
																	<div class="flex mt-2" v-if="Object.keys(work.additionalInfo).includes('evidenceDate')">
																		<p class="font-semibold text-xs">{{'Evidence Date -'}}</p>
																		<p class="mx-2 text-xs">{{ formatDate(work.additionalInfo.evidenceDate)||'N/A' }}</p>
																	</div>

																	<div class="flex" v-if="Object.keys(work.additionalInfo).includes('assignee')">
																		<p class="font-semibold text-xs">{{'Assigned the Task To -'}}</p>
																		<p class="mx-2 text-xs">{{ (work.additionalInfo.name) }}</p>
																	</div>
																	<!-- <div class="flex" v-if="Object.keys(work.additionalInfo).includes('approver')">
																		<p  v-if="Object.keys(work.additionalInfo).includes('action') && work.additionalInfo.action==10301" class="font-semibold text-xs">{{'Requested approval from -'}}</p>
																		<p  v-else-if="!Object.keys(work).includes('action') && !Object.keys(work).includes('additionalInfo') &&work.additionalInfo.statusCode!=undefined && work.additionalInfo.statusCode!=10410" class="font-semibold text-xs">{{'Request approved By -'}}</p>
																		<div
																			v-else-if="!Object.keys(work).includes('action') && Object.keys(work).includes('additionalInfo') && work.additionalInfo.statusCode != undefined && work.additionalInfo.statusCode == 10410"
																			class="flex flex-col"
																			>
																			<p class="font-semibold text-xs">{{'Request Rejected By -'}}</p>

																			<div
																				v-if="work.additionalInfo.justification != undefined"
																				class="flex items-center gap-2"
																			>
																				<p class="font-semibold text-xs">Justification :</p>
																				<p class="text-xs text-justify">{{ work.additionalInfo.justification }}</p>
																			</div>
																			</div>
																		<p class="mx-2 text-xs text-justify">{{ (work.additionalInfo.name) }}</p>
																	</div> -->
																	<div class="flex" v-if="Object.keys(work.additionalInfo).includes('approver')">
																			<!-- Requested approval -->
																			<template v-if="Object.keys(work.additionalInfo).includes('action') && work.additionalInfo.action == 10301">
																				<p class="font-semibold text-xs">Requested approval from -</p>
																				<p class="mx-2 text-xs text-justify">{{ work.additionalInfo.name }}</p>
																			</template>

																			<!-- Approved -->
																			<template v-else-if="!Object.keys(work).includes('action') && !Object.keys(work).includes('additionalInfo') && work.additionalInfo.statusCode != undefined && work.additionalInfo.statusCode != 10410">
																				<p class="font-semibold text-xs">Request approved By -</p>
																				<p class="mx-2 text-xs text-justify">{{ work.additionalInfo.name }}</p>
																			</template>

																			<!-- Rejected -->
																			<div
																				v-else-if="!Object.keys(work).includes('action') && Object.keys(work).includes('additionalInfo') && work.additionalInfo.statusCode != undefined && work.additionalInfo.statusCode == 10410"
																				class="flex flex-col gap-1"
																			>
																				<!-- Row 1: Rejected by + name -->
																				<div class="flex items-center">
																				<p class="font-semibold text-xs">Request Rejected By -</p>
																				<p class="mx-2 text-xs text-justify">{{ work.additionalInfo.name }}</p>
																				</div>

																				<!-- Row 2: Justification + value -->
																				<div
																				v-if="work.additionalInfo.justification != undefined"
																				class="flex items-center gap-2"
																				>
																				<p class="font-semibold text-xs">Justification :</p>
																				<p class="text-xs text-justify">{{ work.additionalInfo.justification }}</p>
																				</div>
																			</div>
																			</div>
																	<div class="flex items-center" v-if="Object.keys(work.additionalInfo).includes('previousStatus')">
																		<div>
																			<p class="font-semibold text-xs">{{'Updated The Status :'}}</p>
																		</div>
																		<div class="flex ml-4">
																			<div class="flex items-center justify-center rounded h-5 labelWidth" :class="colorTemplateBg(work.additionalInfo.previousStatus)">
																				<div :class="colorTemplateText(work.additionalInfo.previousStatus)">
																					{{ getStatusLabel(work.additionalInfo.previousStatus) }}
																				</div>
																			</div>
																			<div class="mx-4 flex items-center"><img src="@/assets/arrowRight.svg"/></div>
																			<div class="flex items-center justify-center rounded h-5 labelWidth" :class="colorTemplateBg(work.additionalInfo.updatedStatus)">
																				<div :class="colorTemplateText(work.additionalInfo.updatedStatus)">
																					{{ getStatusLabel(work.additionalInfo.updatedStatus) }}
																				</div>
																			</div>
																		</div>
																	</div>
																	<div class="flex items-center gap-2 mt-2" v-if="work.additionalInfo.justification != undefined && work.additionalInfo.justification != ''">
																		<p class="font-semibold text-xs">Justification :</p>
																		<p class="text-xs text-justify">{{ work.additionalInfo.justification }}</p>
																	</div>
																</div>
																
															</div>
														</div>
													</div>
												</div>
											</div>
										</div>
									</TabPanel>
								</TabPanels>
							</Tabs>
							<div class="w-20 border taskDetailsRightBar rounded-sm border-lightgrey">
								<div class="m-3">
									<div class="pb-2 border-b border-lightgrey">
										<h1>Task Details</h1>
									</div>
									<div v-if="dotsLoader == true">
										<div class="flex items-center justify-center w-full h-16 skeleton">
											<dotsloader/>
										</div>
									</div>
									<div v-else class="pt-1.5 overflow-y-scroll thirtyWidthToggle">
										<div class="flex flex-col mb-3">
											<label class="controllabel">Task Status</label>
											<!-- :class="changeBackground()" -->
											<div v-if="(presentSubTask.statusCode == 10403)" :class="changeBackground()" class="taskstatusboxstyling cursor-pointer" >
												<div :class="changeBackground()" @change="updateTaskStatus(TaskDetailsDropDown.taskStatus)">
													{{ 
														subTaskStatuses.find((data)=>{
															return data.id == presentSubTask.statusCode
														})?.label||'N/A'
													}}
												</div>
											</div>
											<div v-else-if="(presentSubTask.statusCode == 10423)" :class="changeBackground()" class="taskstatusboxstyling cursor-pointer" >
												<div :class="changeBackground()" @change="updateTaskStatus(TaskDetailsDropDown.taskStatus)">
													{{ 
														subTaskStatuses.find((data)=>{
															return data.id == presentSubTask.statusCode
														})?.label||'N/A'
													}}
												</div>
											</div>
											<div v-else-if="(presentSubTask.statusCode == 10410)" :class="changeBackground()" class="taskstatusboxstyling cursor-pointer" >
												<div :class="changeBackground()" @change="updateTaskStatus(TaskDetailsDropDown.taskStatus)">
													{{ 
														subTaskStatuses.find((data)=>{
															return data.id == presentSubTask.statusCode
														})?.label||'N/A'
													}}
												</div>
											</div>
											<div v-else-if="(presentSubTask.statusCode == 10420 )" :class="changeBackground()" class="taskstatusboxstyling cursor-pointer" >
												<div :class="changeBackground()" @change="updateTaskStatus(TaskDetailsDropDown.taskStatus)">
													{{ 
														statuses.find((data)=>{
															return data.id == presentSubTask.statusCode
														})?.label||'N/A'
													}}
												</div>
											</div>
											<div v-else-if="(presentSubTask.statusCode == 10418 )" :class="changeBackground()" class="taskstatusboxstyling cursor-pointer" >
												<div :class="changeBackground()" @change="updateTaskStatus(TaskDetailsDropDown.taskStatus)">
													{{ 
														statuses.find((data)=>{
															return data.id == presentSubTask.statusCode
														})?.label||'N/A'
													}}
												</div>
											</div>
											<div v-else-if="(presentSubTask.statusCode == 10421 )" :class="changeBackground()" class="taskstatusboxstyling cursor-pointer" >
												<div :class="changeBackground()" @change="updateTaskStatus(TaskDetailsDropDown.taskStatus)">
													{{ 
														statuses.find((data)=>{
															return data.id == presentSubTask.statusCode
														})?.label||'N/A'
													}}
												</div>
											</div>
											<div v-else>
												<!-- <select
													class="custom-select cursor-pointer w-full px-2.5 py-1 text-sm font-light text-gray rounded-sm border-solid border border-lightgrey"
													:class="changeBackground()"
													v-if="(presentSubTask.statusCode != 10402)"
													:disabled="presentSubTask.statusCode == 10403"
													v-model="TaskDetailsDropDown.taskStatus"
													@change="updateTaskStatus(TaskDetailsDropDown.taskStatus)"
												>
													<option value="" selected disabled hidden>Please select one</option>
													<option v-for="i in SubTaskStatus" :value="i.id" :key="i">
														{{ i.value }}
													</option>
												</select> -->
												<!-- {{ taskStatuses }}--{{ SubTaskStatus1 }} -->
												<Select
												v-model="TaskDetailsDropDown.taskStatus"
												:options="taskStatuses"
												v-if="(presentSubTask.statusCode != 10402)"
												:disabled="presentSubTask.statusCode == 10403||presentSubTask.statusCode == 10420 || isAddDisabled(10302)"
												@change="updateTaskStatus(TaskDetailsDropDown.taskStatus)"
												optionLabel="label"
												optionValue="id"
												class="custom-select cursor-pointer w-full px-2.5 py-1 text-sm font-light text-gray rounded-sm border-solid border border-lightgrey"
												:class="changeBackground()"

												/>
												<!-- <select
													class="custom-select cursor-pointer w-full px-2.5 py-1 text-sm font-light text-gray rounded-sm border-solid border border-lightgrey"
													:class="changeBackground()"
													:disabled="presentSubTask.statusCode == 10403"
													v-else
													v-model="TaskDetailsDropDown.taskStatus"
													@change="updateTaskStatus(TaskDetailsDropDown.taskStatus)"
												>
													<option value="" selected disabled hidden>Please select one</option>
													<option v-for="i in SubTaskStatus1" :value="i.id" :key="i">
														{{ i.value }}
													</option>
												</select> -->
												<Select
												v-model="TaskDetailsDropDown.taskStatus"
												:options="subTaskStatuses"
												v-else
												:disabled="presentSubTask.statusCode == 10403||presentSubTask.statusCode == 10420 || isAddDisabled(10302)"
												@change="updateTaskStatus(TaskDetailsDropDown.taskStatus)"
												optionLabel="label"
												optionValue="id"
												class="custom-select cursor-pointer w-full px-2.5 py-1 text-sm font-light text-gray rounded-sm border-solid border border-lightgrey"
												:class="changeBackground()"
												/>
											</div>
											
										</div>
			
										
										<div class="mb-3">
											<div>
												<label class="controllabel">Assigned To</label>
												<!-- <div class="mt-2" v-if="presentSubTask.statusCode == 10403 || (presentSubTask.createdBy == userInfo._id && presentSubTask.assignee != undefined && presentSubTask.assignee.value != userInfo._id)">
													{{presentSubTask.assignee != undefined ? presentSubTask.assignee.label : 'N/A'}}
												</div> -->
												<div>
													<!-- <multiselect
														v-model="presentSubTask.assignee"
														:options="userOptions"
														:showNoOptions="false"
														@search-change="asyncFind"
														:limit-text="limitText"
														:multiple="false"
														:close-on-select="true"
														:disabled="presentSubTask.statusCode == 10403"
														:clear-on-select="true"
														label="label"
														open-direction="bottom"
														:hide-selected="true"
														track-by="value"   
														@select="updateAssignedMember(presentSubTask.assignee)" 
														:searchable="true"
														:hideArrow="false"
														placeholder="Assigned-To"
														deselectLabel=""
														selectLabel=""
														class="custom-multiselect userSelect"
														:class="{
															'has-options': userOptions && userOptions.length > 0,
															'no-options': !userOptions.length &&  searchValue !== '',
														}"
													>
														<template v-slot:noResult>
															<span>No Members Found</span>
														</template>
													</multiselect> -->
													<AutoComplete 
														v-model="presentSubTask.assignee"
														:suggestions="userOptions"
														@complete="asyncFind"
														@item-select="updateAssignedMember(presentSubTask.assignee)" 
														:disabled="presentSubTask.statusCode == 10403||presentSubTask.statusCode == 10420 || presentSubTask.statusCode==10423|| presentSubTask.statusCode==10410|| presentSubTask.statusCode == 10418 ||isAddDisabled(10302)"
														optionLabel="label"
														optionValue="value"
														placeholder="Assigned-To"
														class="p-inputtext-sm systemsstyling  mt-2 custom-multiselect userSelect"
														:class="{
															'has-options': userOptions && userOptions.length > 0,
															'no-options': !userOptions.length &&  searchValue !== '',
														}"
													>
													<template #empty>
														<div class="text-sm">
															<span>No Members Found</span>
														</div>
													</template>
													</AutoComplete>
												</div>
											</div>
										</div>
										<div class="mb-3">
											<label class="controllabel mb-2">Created By</label><br>
											<!-- show process Owner -->
											<div class="my-1">{{ getPersonName(presentSubTask.createdBy,presentSubTask.createdPersonName) }}</div>
										</div>
										<div class="mb-3" v-if='(presentSubTask.appId && presentSubTask.appId==10003)|| presentSubTask.treatmentType!=undefined'>
											<label class="controllabel mb-2">Treatment Type</label><br>
						
											<div class="flex items-center justify-center rounded h-5 w-24 mt-2 mb-3" :class="treatmentTypeBgColor(presentSubTask.treatmentType)">
												<div class="text-xs" :class="treatmentTypeTextColor(presentSubTask.treatmentType)">
												{{ presentTask(presentSubTask.treatmentType)||'N/A' }}
												</div>
											</div>
											
										</div>
										<div class="mb-3">
											<!-- <label class="controllabel mb-2">Start Date</label><br>
											<div class="my-1">{{ formatDate(presentSubTask.startDate)}}</div> -->
											<!-- show Start Date -->
											<div>
												<label class="controllabel">Start Date</label>
												<input
													type="date"
													v-model="presentSubTask.startDate"
													class="mt-2 w-full stylingForInputboxstylingForSelectAtPopup"
													@focus="openCalendar"
													onkeydown="return false"
													placeholder="Select Date"
													:disabled="TaskDetailsDropDown.taskStatus ==10403||TaskDetailsDropDown.taskStatus==10423||TaskDetailsDropDown.taskStatus==10410|| presentSubTask.statusCode == 10418"
													:max="presentSubTask.dueDate"
													@change="updateDate(presentSubTask.startDate,20604)"
												/>
                                        	</div>
										</div>
										<div class="mb-3">
											<!-- <label class="controllabel mb-2">Due Date</label><br> -->
											<!-- show Due Date -->
											<!-- <div class="my-1">{{ presentSubTask.dueData }}</div> -->
											<!-- <div v-if="(presentSubTask.dueDate!= undefined || presentSubTask.dueDate!= null ) && presentSubTask.dueDate!=''" class="my-1">{{ formatDate(presentSubTask.dueDate) }}</div>
											<div v-else class="my-1">N/A</div> -->
											<div>
                                                <label class="controllabel">Due Date</label>
                                                <input
                                                    type="date"
                                                    v-model="presentSubTask.dueDate"
                                                    class="mt-2 w-full stylingForInputboxstylingForSelectAtPopup"
                                                    @focus="openCalendar"
                                                    onkeydown="return false"
                                                    placeholder="Select Date"
													:disabled="TaskDetailsDropDown.taskStatus ==10403||TaskDetailsDropDown.taskStatus==10423||TaskDetailsDropDown.taskStatus==10410|| presentSubTask.statusCode == 10418"
                                                    :min="presentSubTask.startDate"
                                                    @change="updateDate(presentSubTask.dueDate,20605)"
                                                />
                                            </div>
										</div>
										<div class="mb-3">
											<label class="controllabel mb-2">Completion Date</label><br>
											<!-- show Start Date -->
											<!-- <div class="my-1">{{ formatDate(presentSubTask.completedAt)}}</div> -->
											 <input
													type="date"
													v-model="presentSubTask.completedAt"
													class="mt-2"
													@focus="openCalendar"
													:min="presentSubTask.startDate"
													placeholder="Select Date"
													:disabled="TaskDetailsDropDown.taskStatus ==10403||TaskDetailsDropDown.taskStatus==10423||TaskDetailsDropDown.taskStatus==10410|| presentSubTask.statusCode == 10418"
													@change="updateCompletionDate(presentSubTask.completedAt)"
													:class="{'inputboxstylingForSelectAtPopup': presentSubTask.startDate === '','stylingForInputboxstylingForSelectAtPopup': presentSubTask.startDate !== ''}"
												/>
												<!-- <div v-if="v$.presentSubTask.completedAt.$error" class="text-red-500">
													<div class="error-text" v-if="v$.presentSubTask.completedAt.required.$invalid">Required</div>
												</div> -->
										</div>
										
										<div class="mb-3">
											<label class="controllabel mb-2">Team</label><br>
											<!-- {{ presentSubTask.team }} -->
											<div>{{ getUserteamName(presentSubTask.departments) }}</div>
											<!-- <div v-else class="my-1">N/A</div> -->
										</div>
										<div class="mb-3">
											<label class="controllabel mb-2">Location</label><br>
											<div>{{ getLocationName(presentSubTask.entity) }}</div>
										</div>
										<div class="mb-3">
											<label class="controllabel mb-2">Tier</label><br>
											<!-- {{ presentSubTask.team }} -->
											<div>{{ getTargetTitle(presentSubTask) }}</div>
											<!-- <div v-else class="my-1">N/A</div> -->
										</div>
										<div class="mb-3">
											<label class="controllabel mb-2">Scope</label><br>
											<!-- {{ presentSubTask.team }} -->
											<div>{{ getTargetInfo(presentSubTask) }}</div>
											<!-- <div v-else class="my-1">N/A</div> -->
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div v-if="showDeleteEvidenceConfirm" class="evidence-delete-confirm">
			<div class="evidence-delete-backdrop" @click="cancelDeleteEvidence"></div>
			<div class="evidence-delete-dialog">
				<div class="evidence-delete-dialog-title">
					<div class="evidence-delete-warning">
						<img src="@/assets/warning.svg" class="evidence-delete-warning-icon" alt="" />
					</div>
					<span>Delete Evidence</span>
				</div>
				<p class="evidence-delete-dialog-message">Are you sure you want to delete this evidence?</p>
				<div class="evidence-delete-dialog-actions">
					<button type="button" class="evidence-delete-cancel" @click="cancelDeleteEvidence">Cancel</button>
					<button type="button" class="evidence-delete-ok" @click="confirmDeleteEvidence">OK</button>
				</div>
			</div>
		</div>
		<popup v-if="importpopUp" :popUp="importpopUp">
			<div class="overflow-x-hidden overflow-y-auto fixed inset-0 z-index justify-end items-start flex">
			<div class="relative w-full max-w-xl">
			<!--content-->
			<div class="border-0 rounded relative flex flex-col w-full bg-white h-screen">
				<!--header-->
				<div class="flex items-center justify-between popupheadingcontainer rounded">
				<h1>{{ evidenceAttachMode === 'url' ? 'Attach Link' : 'Attach File' }}</h1>
				<button class="p-1 ml-auto float-right text-3xl leading-none font-semibold outline-none focus:outline-none" @click="onCancelIcon()">
					<img src="@/assets/cancel.svg" class="h-5 w-5 cursor-pointer" />
				</button>
				</div>
				<div class="border-b border-solid border-lightgrey ml-4 mr-4"></div>
				<div class="impactcontainer popupbodycontainer flex-1 overflow-y-auto">
				<div class="formcontainer flex flex-col h-full">
					<div class="flex-1 overflow-auto hide-scrollbar">
						<div class="row flex flex-col mt-2">
						<div>
							<label class="controllabel">{{ evidenceAttachMode === 'url' ? 'Title' : 'File Name' }} </label>
							<input v-if="evidenceAttachMode === 'url'" class="inputboxstyling mt-2" type="text" v-model.trim="inputFileName" placeholder="Evidence title" @input="v$.inputFileName.$touch()"  :class="{'is-invalid': v$.inputFileName.$error }"/>
							<input
								v-else
								class="inputboxstyling mt-2"
								type="text"
								v-model.trim="inputFileName"
								placeholder="Filename"
								@input="v$.inputFileName.$touch()"
								:class="{'is-invalid': v$.inputFileName.$error }"
							/>
							<div v-if="v$.inputFileName.$error " class="text-red-500">
								<div class="error-text text-xs" v-if="v$.inputFileName.required.$invalid ">Required</div>
								<div v-else-if="v$.inputFileName.restrictCharacters50 && v$.inputFileName.restrictCharacters50.$invalid" class="error-text text-xs">Charcter Limit is exceeded</div>
							</div>
						</div>
						<div class="pt-3" v-if="evidenceAttachMode === 'file'">
                <label class="controllabel">Attachment</label>
                <input
                  type="file"
                  ref="fileInput"
                  class="hidden"
                  id="upload"
                  @change="handleFileUpload"
                />
                <div 
                  class="w-auto rounded-sm mt-2 p-8
                        flex flex-col items-center justify-center text-center transition
                        border-2 border-dashed border-lightgrey bg-whitegrey"
                  :class="{
                    'is-invalid': v$.fileToUpload.$error || pdfValidation,
                    'border-primary': isDragOver
                  }"
                  @dragenter.prevent="onDragOver"
                  @dragover.prevent="onDragOver"
                  @dragleave.prevent="onDragLeave"
                  @drop.prevent="onFileDrop"
                >
                  <img
                    src="@/assets/fileUploadIcon.svg"
                    class="h-10 w-10 mb-3"
                    alt="Upload file"
                  />

                  <p v-if="fileName === ''" class="text-sm font-semibold text-darkblue mb-4">
                    Drag and drop your file here
                  </p>
                  <p v-else class="text-sm font-semibold text-primary mb-4">
                    {{ fileName }}
                  </p>
                  <div class="flex items-center justify-center gap-2">
                    <label for="upload" class="cursor-pointer">
                      <span class="browseBtnprimary text-xs gap-1">
                        <img src="@/assets/Browse.svg" class="h-4 w-4" alt="" />
                        Browse
                      </span>
                    </label>

                    <button
                      type="button"
                      class="text-xs gap-1"
                      :class="fileName === '' ? 'filterButtondisabled pointer-events-none' : 'filterButton'"
                      :disabled="fileName === ''"
                      @click="clearSelectedFile"
                    >
                      Cancel
                    </button>
                  </div>
                </div>
					<div class="min-h-[22px] text-red-500">
					<div
						v-if="v$.fileToUpload.$invalid && !pdfValidation && (v$.fileToUpload.$error || pdfValidation)"
						class="error-text text-xs"
					>
						File upload is required
					</div>
					<div
						v-if="pdfValidation && !v$.fileToUpload.$invalid"
						class="text-red-500 text-xs"
					>
						This File Format is not Supported
					</div>
					</div>
						<div class="mt-2 flex flex-col items-center">
						<p class="text-xs text-placeholdergray">
						Accepted Formats: PDF, JPG, PNG, ZIP, TXT, XLS, DOC, MP4
						</p>
						<p class="text-xs text-placeholdergray mt-1">
						Maximum File Size: 50 MB
						</p>
					</div>
					</div>
						<div class="pt-3" v-if="evidenceAttachMode === 'url'">
							<label class="controllabel">URL</label>
							<input
								class="inputboxstyling mt-2"
								type="url"
								v-model.trim="evidenceUrl"
								placeholder="URL"
								@input="v$.evidenceUrl.$touch()"
								:class="{'is-invalid': v$.evidenceUrl.$error }"
							/>
							<div v-if="v$.evidenceUrl.$error" class="text-red-500">
								<div class="error-text text-xs" v-if="v$.evidenceUrl.required.$invalid">Required</div>
								<div class="error-text text-xs" v-else-if="v$.evidenceUrl.httpUrl.$invalid">URL must use http or https</div>
							</div>
							<!-- <p class="text-xs text-placeholdergray mt-2">
								Example: https://sharepoint.com/... or https://drive.google.com/...
							</p> -->
						</div>
						<div class="pt-3 w-1/2">
							<label class="controllabel">{{'Evidence Date' }}</label>
							<input
								v-model="evidenceDate"
								type="date"
								class="mt-2 w-full inputboxstylingForSelectAtPopup"
								@focus="openCalendar"
								style="height:28px"
								onkeydown="return false"
								:class="{
									'inputboxstylingForSelectAtPopup': evidenceDate === '',
									'stylingForInputboxstylingForSelectAtPopup': evidenceDate !== '',
									'is-invalid':v$.evidenceDate.$error
									}"
								
								placeholder="Select Date"
								:max="todayDate"

							/>
							<div v-if="v$.evidenceDate.$error" class="text-red-500">
								<div v-if="v$.evidenceDate.$invalid" class="error-text text-xs">{{'Evidence date is required'}}</div>
							</div>
						</div>

						</div>
					</div>
					<div>
					<div class="border-b border-solid border-lightgrey"></div>
					<div class="buttonposition flex justify-end items-center pt-4">
						<button class="btnprimary" @click="onEvidenceSave" :class="isEvidenceSaveDisabled ? 'btndisabled pointer-events-none ' : 'btnprimary'">Save</button>
					</div>

					</div>
				</div>
				</div>
				<!--footer-->
			</div>
			</div>
			</div>
		</popup>
		<div v-if="linkEvidencePopup" class="link-existing-confirm">
			<div class="link-existing-backdrop" @click="closeLinkEvidencePopup"></div>
			<div class="link-existing-dialog">
				<div class="link-existing-title">
					<span class="link-existing-warning" aria-hidden="true">
						<img src="@/assets/warning.svg" class="link-existing-warning-icon" alt="" />
					</span>
					<span>Link Existing Evidence</span>
				</div>
				<p class="link-existing-message">Select evidence from the past year listed below.</p>
				<div class="link-existing-tables">
					<div class="link-existing-section-row">
						<div class="link-existing-section">EXISTING EVIDENCE ({{ filteredSortedExistingEvidences.length }})</div>
						<button type="button" class="filterButton flex" @click="toggleExistingEvidenceFilters">
							<img src="@/assets/filterIcon.svg" class="filterIcon" />
							Filters
						</button>
					</div>
					<div class="link-existing-table-wrap" :class="{ 'link-existing-table-wrap--empty': filteredSortedExistingEvidences.length === 0 }">
						<table class="link-existing-table">
							<thead>
								<tr>
									<th class="link-existing-col-check"></th>
									<th class="cursor-pointer" @click="sortExistingEvidence('filename')">
										<div class="flex table-header-label-wrap">
											<div class="table-header-label">TITLE</div>
											<div class="sort cursor-pointer" :class="existingEvidenceSortKey === 'filename' ? existingEvidenceSortClass : 'opacity-50'"></div>
										</div>
									</th>
									<th class="cursor-pointer" @click="sortExistingEvidence('sourceTaskId')">
										<div class="flex table-header-label-wrap">
											<div class="table-header-label">TASK ID</div>
											<div class="sort cursor-pointer" :class="existingEvidenceSortKey === 'sourceTaskId' ? existingEvidenceSortClass : 'opacity-50'"></div>
										</div>
									</th>
									<th class="cursor-pointer" @click="sortExistingEvidence('evidenceType')">
										<div class="flex table-header-label-wrap">
											<div class="table-header-label">TYPE</div>
											<div class="sort cursor-pointer" :class="existingEvidenceSortKey === 'evidenceType' ? existingEvidenceSortClass : 'opacity-50'"></div>
										</div>
									</th>
									<th class="cursor-pointer" @click="sortExistingEvidence('evidenceDate')">
										<div class="flex table-header-label-wrap">
											<div class="table-header-label">EVIDENCE DATE</div>
											<div class="sort cursor-pointer" :class="existingEvidenceSortKey === 'evidenceDate' ? existingEvidenceSortClass : 'opacity-50'"></div>
										</div>
									</th>
								</tr>
								<tr v-if="showExistingEvidenceFilters" class="link-existing-filter-row">
									<td class="link-existing-col-check"></td>
									<td><input type="text" class="searchForInputBoxStyling" v-model.trim="existingEvidenceFilters.filename" placeholder="Search" @click.stop /></td>
									<td><input type="text" class="searchForInputBoxStyling" v-model.trim="existingEvidenceFilters.sourceTaskId" placeholder="Search" @click.stop /></td>
									<td><input type="text" class="searchForInputBoxStyling" v-model.trim="existingEvidenceFilters.evidenceType" placeholder="Search" @click.stop /></td>
									<td></td>
								</tr>
							</thead>
							<tbody v-if="filteredSortedExistingEvidences.length">
								<tr v-for="row in filteredSortedExistingEvidences" :key="row.optionKey">
									<td class="link-existing-col-check">
										<input type="checkbox" :checked="isExistingEvidenceSelected(row)" @change="toggleExistingEvidence(row)" />
									</td>
									<td :title="row.filename">{{ row.filename }}</td>
									<td>{{ row.sourceTaskId }}</td>
									<td>{{ getEvidenceTypeLabel(row) }}</td>
									<td>{{ row.evidenceDate ? formatFileAttachedTime(row.evidenceDate) : 'N/A' }}</td>
								</tr>
							</tbody>
							<tbody v-else>
								<tr>
									<td class="link-existing-empty" colspan="5">No Records Found</td>
								</tr>
							</tbody>
						</table>
					</div>
				</div>
				<div class="link-existing-actions">
					<button type="button" class="link-existing-cancel" @click="closeLinkEvidencePopup">Cancel</button>
					<button type="button" class="link-existing-save" @click="saveLinkedEvidence" :class="selectedExistingEvidences.length === 0 ? 'link-existing-save-disabled' : ''">Save</button>
				</div>
			</div>
		</div>
		<popup v-if="showApprovalPopup" :popUp="showApprovalPopup">
			<template v-slot:header>
				<div class="flex items-center justify-between popupheadingcontainer rounded">
					<h1>Approval</h1>

					<button class="float-right text-3xl" @click="onCrossbtn()">
						<img src="@/assets/cancel.svg" class="h-5 w-5 cursor-pointer" />
					</button>
				</div>
			</template>

			<div class="popup-business flex-1 overflow-y-auto">
				<div class="flex flex-col h-full ">
					<div class="flex-1 overflow-auto hide-scrollbar">
						<div>
							<div class="statuscontainer px-5 pb-5">
								<div class="formcontainer flex flex-col">
									<div class="row flex flex-row upperspacing">
										<div class=" w-1/2">
											<label class="controllabel">Name of the Authority</label>
											<div>
											<!-- <multiselect
												v-model="taskObj.approver"
												:options="authorityOptions"
												:showNoOptions="false"
												@search-change="asyncFind1"
												:limit-text="limitText"
												:multiple="false"
												label="label"
												open-direction="bottom"
												track-by="value"
												:searchable="true"
												:hideArrow="false"
												placeholder="Assigned-To"
												deselectLabel=""
												selectLabel=""
												class="custom-multiselect userSelect"
												:class="{
													'is-invalidmultiselect': v$.taskObj.approver.$error,
													'has-options': userOptions && userOptions.length > 0,
													'no-options': !userOptions.length &&  searchValue !== '',
												}"
											></multiselect> -->
											<AutoComplete
												v-model="taskObj.approver"
												:suggestions="authorityOptions"
												@complete="asyncFind1"
												optionLabel="label"
												optionValue="value"
												field="label"
												appendTo="self"
												:forceSelection="false"
												placeholder="Assigned-To"
												class="p-inputtext-sm systemsstyling"
												:class="{
													'p-invalid':  v$.taskObj.approver.$error,
													'has-options': authorityOptions && authorityOptions.length > 0,
													'no-options': !authorityOptions.length &&  searchValue !== '',
												}"
											/>
											
										</div>
										<div v-if="v$.taskObj.approver.$error " class="text-red-500">
											<div class="error-text" v-if="v$.taskObj.approver.$invalid ">Required</div>
										</div>
											
										</div >
									</div>
									<div class="row flex flex-row upperspacing">
										<div class="w-full">
											<label class="controllabel">Justification or Comments for Approving</label>
											<textarea
												class="inputboxstyling mt-2"
												placeholder="Comments"
												v-model.trim="taskObj.approvalComments"
												:class="{'is-invalid': v$.taskObj.approvalComments.$error }"
											/>
											<div v-if="v$.taskObj.approvalComments.$error " class="text-red-500">
												<div class="error-text" v-if="v$.taskObj.approvalComments.$invalid ">Required</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div>
						<div class="border-b border-solid border-lightgrey mx-5"></div>
						<div class="buttonposition flex justify-end items-center pb-4 pl-5 pt-4 pr-5">
							<button class="btnprimary mr-1.5" :class="(JSON.stringify(taskObj) == JSON.stringify(taskObjDummy)) ? 'btndisabled pointer-events-none ' : 'btnprimary'" @click="onCancelbtnAtApproval()">Reset</button>
							<button class="btnprimary" :class="(JSON.stringify(taskObj) == JSON.stringify(taskObjDummy)) ? 'btndisabled pointer-events-none ' : 'btnprimary'" @click="clickOnSaveForApproval(taskObj)">Save</button>
						</div>

					</div>
				</div>
			</div>
		</popup>
		 <popup v-if="showRejectPopupAtInReview" :popUp="showRejectPopupAtInReview">
      <template v-slot:header>
        <div
          class="flex items-center justify-between popupheadingcontainer rounded"
        >
          <h1>{{ isRiskTaskReject ? 'Justification to Reject the Task' : 'Justification to Reject an Approval' }}</h1>

          <button class="float-right text-3xl" @click="onCrossBtnForFinalApproval()">
            <img src="@/assets/cancel.svg" class="cursor-pointer" />
          </button>
        </div>
      </template>
  <div class='flex flex-col h-full'>
    <div class="flex-1 overflow-auto">
      <div class="popup-business">
        <div>
          <div>
            <div class="statuscontainer px-4 py-4">
              <div class="formcontainer flex flex-col w-full">
                    <label class="controllabel"
                      >Justification or Comments for Rejecting</label
                    >
                    <textarea
                      class="inputboxstyling mt-2"
                      placeholder="Comments"
                      v-model.trim="finalJustification.justification"
                      @input="v$.finalJustification.justification.$touch()" 
                      :class="{ 'is-invalid': v$.finalJustification.justification.$error }"
                    />
                    <div v-if="v$.finalJustification.justification.$error" class="text-red-500">
                      <div v-if="v$.finalJustification.justification.restrictCharacters1000.$invalid" class="error-text text-xs">Charcter Limit is exceeded</div>
                    </div>
              </div>
            </div>
          </div>
          
        </div>
      </div>
    </div>
    <div>
      <div class="border-b border-solid border-lightgrey mx-5"></div>
        <div
            class="buttonposition flex justify-end items-center pb-4 pl-5 pt-4 pr-5"
          >
            <button
              class="btnprimary mr-2"
              :class="
                finalJustification.justification == ''
                  ? 'btndisabled pointer-events-none'
                  : 'btnprimary'
              "
              @click="onCancelbtnForFinalApproval()"
            >
              Reset
            </button>
            <button
              :disabled="clickOnButtonForFinal"
              class="btnprimary"
              :class="
                finalJustification.justification == ''
                  ? 'btndisabled pointer-events-none'
                  : 'btnprimary'
              "
              @click="isRiskTaskReject ? confirmRiskTaskReject() : approveOrRejectForActionTasktoComplete(10410, 9)"
            >
              Save
            </button>
          </div>
        </div>
      </div>
    </popup>
	</div>
</template>
<style scoped>
.evidence-links-col-action {
	width: 8%;
	min-width: 40px;
	text-align: center;
}
.evidence-delete-confirm {
	position: fixed;
	inset: 0;
	z-index: 10060;
	display: flex;
	align-items: center;
	justify-content: center;
}
.evidence-delete-backdrop {
	position: fixed;
	inset: 0;
	background: rgba(0, 0, 0, 0.4);
}
.evidence-delete-dialog {
	position: relative;
	display: block;
	width: 460px;
	max-width: calc(100% - 32px);
	background: #fff;
	border-radius: 6px;
	box-shadow: 0 8px 24px rgba(0, 0, 0, 0.18);
	padding: 20px 24px 16px;
	box-sizing: border-box;
}
.evidence-delete-dialog-title {
	display: flex;
	align-items: center;
	gap: 12px;
	width: 100%;
	margin: 0;
	font-size: 16px;
	font-weight: 700;
	line-height: 22px;
	color: #1a1a1a;
}
.evidence-delete-warning {
	height: 40px;
	width: 40px;
	border-radius: 9999px;
	background: #FFE8D6;
	display: flex;
	align-items: center;
	justify-content: center;
	flex-shrink: 0;
}
.evidence-delete-warning-icon {
	height: 24px;
	width: 24px;
}
.evidence-delete-dialog-message {
	display: block;
	width: 100%;
	margin: 12px 0 0;
	font-size: 14px;
	line-height: 20px;
	color: #333;
}
.evidence-delete-dialog-actions {
	display: flex;
	justify-content: flex-end;
	align-items: center;
	gap: 8px;
	width: 100%;
	margin-top: 20px;
}
.evidence-delete-cancel,
.evidence-delete-ok {
	height: 32px;
	min-width: 72px;
	padding: 0 16px;
	border-radius: 4px;
	font-size: 14px;
	font-weight: 600;
	line-height: 30px;
	cursor: pointer;
	box-sizing: border-box;
}
.evidence-delete-cancel {
	background: #fff;
	border: 1px solid #d9d9d9;
	color: #333;
}
.evidence-delete-ok {
	background: #1976d2;
	border: 1px solid #1976d2;
	color: #fff;
}
.widthForCommentBox{
	width : 75px;
}
.imageStyling{
	width:30px !important;
	height:30px !important;
}
.w-20{
	width: 20%;
}
.w-80{
	width: 80%;
}
.attachmargin{
	margin-bottom : 2.5px;
}
.progressbarB {
	border: 2px solid var(--color-lightgrey);
	background: var(--color-lightgrey);
	position: relative;
	top: -8px;
	z-index: 1;
}
.numberBorder{
    border-top: 1px solid var(--color-lightgrey);
    border-right: 1px solid var(--color-lightgrey);
    border-bottom: 1px solid var(--color-lightgrey);
}
.numberNavy{
    border-left: 2px solid var(--color-primary);
    /* border-width: 2px; */
}
.progress {
	background: var(--color-primary);
	position: relative;
	border-radius: 4px;
	z-index: 2;
}
.primaryBackground{
	background-color: var(--color-primary)
}
.descriptionToggle {
	height: 97%;
}
.tabStructure {
	height: calc(100vh - 165px);
}
.thirtyWidthToggle::-webkit-scrollbar {
	width: 0 !important;
	height: 0 !important;
	background: transparent;
}

.thirtyWidthToggle::-webkit-scrollbar-thumb {
	background: transparent;
}
.thirtyWidthToggle{  
     height:  calc(100vh - 250px);
}
.descriptionToggle::-webkit-scrollbar {
	width: 0 !important;
	height: 0 !important;
	background: transparent;
}
.descriptionToggle::-webkit-scrollbar-thumb {
	background: transparent;
}
.heightFixing {
	height:  calc(100vh - 220px);
	/* height : 64vh; */
}
option {
	background-color: #ffffff;
	color: #000000;
	border-color: pink transparent transparent transparent;
}
.textColorWhite {
	color: white;
}
.custom-select {
    background-image: url("../assets/collapseIcon.svg") !important;
    background-repeat: no-repeat no-repeat;
    background-position: center center;
    background-size: 12px 12px;
    background-position: right 15px center; /* Change the px value here to change the distance */
    -moz-appearance: none;
    -webkit-appearance: none;
    appearance: none;
}
.marginBottomForDoc{
	margin-bottom : 3px;
}
.marginTopForDoc{
	margin-top : 2.5px;
}
.marginBottomZero{
	margin-bottom : 0px;
}
.pendingEvidence{
    background-color: #8600f040;
}
.evidenceUpload{
    background: rgba(21,39,60,0.24);
}
.labelWidth{
	min-width: 7rem;
}
.framework{
	padding: 12px 170px 12px 12px;
}
.findingCategory{
	padding: 12px 80px 12px 12px;
}
.taskstatusboxstyling {
  display: block;
  width: 100%;
  border-radius: 0.25rem;
  border-width: 1px;
  border-style: solid;
  --tw-border-opacity: 1;
  border-color:var(--color-lightgrey);
  --tw-bg-opacity: 1;
  /* background-color: rgba(255, 255, 255, var(--tw-bg-opacity)); */
  padding-left: 0.625rem;
  padding-right: 0.625rem;
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
  font-size: 0.875rem;
  line-height: 1.25rem;
  font-weight: 300;
  --tw-text-opacity: 1;
  /* color: rgba(77, 77, 77, var(--tw-text-opacity)); */
}

.approvalbtndisabled {
	    height: 28px;
    border-radius: 4px;
    border-width: 1px;
    --tw-border-opacity: 1;
    border-color:var(--color-lightgrey);
    --tw-bg-opacity: 1;
    background-color:var(--color-lightgrey);
    padding-left: 20px;
    padding-right: 20px;
    /* font-family: Open Sans; */
    font-size:14px;
    font-weight: 700;
    line-height: 12px;
    --tw-text-opacity: 1;
    color: rgb(77 77 77 / var(--tw-text-opacity));
}
.evidenceHeight{
	height: 29px;
}
.heightForDiv{
  height : 29.333px;
  padding-left: 0.625rem;
  padding-right: 0.625rem;
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
}
.sendapprovalheight{
	height: 40px;
}
:deep(.p-select-dropdown){
  display: none !important;
}
:deep(.p-tab){
  padding: 0px 0px 5px 0px !important;
}
:deep(.p-tabpanels){
  padding-top:5px !important ;
}
:deep(.p-select.p-disabled.bg-disabledgrey),.bg-disabledgrey{
  background-color: #a4a4a4 !important;
  font-weight: 600 !important;
}
:deep(.p-select.p-disabled.bg-yellow),.bg-yellow{
  background-color: #FF9900 !important;
  font-weight: 600 !important;
}
.p-select.p-disabled .p-select-dropdown{
  background-color: #a4a4a4 !important;
  font-weight: 600 !important;
}
:deep(.p-select.p-disabled.bg-electricGreen),.bg-electricGreen{
  background-color: #8600F0 !important;
  font-weight: 600 !important;
}
:deep(.p-select.p-disabled.bg-lightgreen),.bg-lightgreen{
  background-color: #00B050 !important;
  font-weight: 600 !important;
}
:deep(.p-select.p-disabled.bg-darkred),.bg-darkred{
  background-color: #C00000 !important;
  font-weight: 600 !important;
}
:deep(.p-select.p-disabled.bg-error),.bg-error{
  background-color: #FF0000 !important;
  font-weight: 600 !important;
}
:deep(.p-select.p-disabled.bg-primary),.bg-primary{
  background-color: #1976D2 !important;
  font-weight: 600 !important;
}
:deep(.p-select-label){
  color: white !important;
}
:deep(.link-evidence-task-select .p-select-label) {
  color: #000000 !important;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
:deep(.link-evidence-task-select .p-select-label.p-placeholder) {
  color: #adadad !important;
}
:deep(.link-evidence-task-select) {
  position: relative;
}
:deep(.link-evidence-task-select .link-evidence-select-overlay) {
  position: absolute !important;
  top: 100% !important;
  left: 0 !important;
  right: auto !important;
  width: 100% !important;
  min-width: 100% !important;
  max-width: 100% !important;
  transform: none !important;
}
:deep(.link-evidence-select-overlay .p-select-option) {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: block;
}
:deep(.link-evidence-task-select.p-multiselect) {
  height: 32px;
  min-height: 32px;
  align-items: center;
}
:deep(.link-evidence-task-select .p-multiselect-label-container) {
  height: 32px;
  padding: 0 0 0 6px !important;
}
:deep(.link-evidence-task-select .p-multiselect-label) {
  color: #000000 !important;
  flex-wrap: nowrap;
  align-items: center;
  height: 32px;
  gap: 4px;
  overflow: hidden;
}
:deep(.link-evidence-task-select .p-multiselect-label .p-chip) {
  height: 22px;
  max-height: 22px;
  max-width: 120px;
  margin: 0;
  padding: 0 6px !important;
  font-size: 12px;
}
:deep(.link-evidence-task-select .p-chip-label) {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  line-height: 22px;
}
:deep(.link-evidence-task-select .p-multiselect-label.p-placeholder) {
  color: #adadad !important;
  display: flex !important;
  align-items: center !important;
  height: 32px !important;
  padding: 0 40px 0 0 !important;
  line-height: 32px !important;
}
:deep(.link-evidence-select-overlay .p-multiselect-option) {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
:deep(.p-select.p-disabled .p-select-label){
  color: white !important;
}
:deep(.p-select.p-disabled .p-select-dropdown) {
  display: none !important;
}

:deep(.p-select-dropdown-icon){
  color: white !important;
}
.task-details-in-modal {
	height: 100%;
	min-height: 0;
	display: flex;
	flex-direction: column;
	overflow: hidden;
	padding: 0 16px 12px;
	margin: 0;
	box-sizing: border-box;
}
.task-details-in-modal > .items-center {
	flex-shrink: 0;
}
.task-details-in-modal > div:not(.items-center) {
	flex: 1;
	min-height: 0;
	display: flex;
	flex-direction: column;
	overflow: hidden;
}
.task-details-in-modal .minheight,
.task-details-in-modal .minheight > .w-full,
.task-details-in-modal .minheight > .w-full > .text-sm {
	flex: 1;
	min-height: 0;
	height: 100%;
	display: flex;
	flex-direction: column;
	overflow: hidden;
}
.task-details-in-modal .tabStructure {
	flex: 1;
	min-height: 0;
	height: auto !important;
	margin-top: 8px;
	overflow: hidden;
}
.task-details-in-modal .heightFixing {
	height: auto !important;
	min-height: 0;
	overflow: hidden;
	display: flex;
	flex-direction: column;
}
.task-details-in-modal :deep(.p-tabs) {
	height: 100%;
	min-height: 0;
	display: flex;
	flex-direction: column;
	overflow: hidden;
}
.task-details-in-modal :deep(.p-tabs) > div:first-child {
	flex-shrink: 0;
}
.task-details-in-modal :deep(.p-tabpanels) {
	flex: 1;
	min-height: 0;
	height: auto;
	overflow: hidden !important;
}
.task-details-in-modal :deep(.p-tabpanel),
.task-details-in-modal :deep(.p-tabpanel) > div {
	height: 100%;
	min-height: 0;
	overflow: hidden;
}
.task-details-in-modal .descriptionToggle {
	height: 100% !important;
	max-height: 100%;
	overflow-y: auto !important;
	scrollbar-width: thin;
	scrollbar-gutter: stable;
}
.task-details-in-modal .evidence-description {
	padding-right: 4px;
	box-sizing: border-box;
	overflow-y: auto !important;
	display: flex;
	flex-direction: column;
}
.task-details-in-modal .evidence-description .evidence-tab-content {
	flex: 1;
	min-height: 0;
}
.task-details-in-modal .evidence-description .evidence-links-section {
	flex: 1;
	min-height: 280px;
}
.task-details-in-modal .evidence-description .evidence-links-wrap {
	flex: 1;
	min-height: 240px;
	margin-top: 12px !important;
}
.task-details-in-modal .evidence-description .evidence-links-scroll {
	flex: 1;
	min-height: 180px;
	display: flex;
	flex-direction: column;
	overflow-x: auto;
	overflow-y: hidden;
}
.task-details-in-modal .evidence-description .evidence-links-body {
	flex: 1;
	min-height: 180px; /* show at least 3 rows */
	max-height: 600px;
	overflow-y: auto;
}
.task-details-in-modal .taskDetailsRightBar {
	min-height: 0;
	overflow: hidden;
	display: flex;
	flex-direction: column;
}
.task-details-in-modal .taskDetailsRightBar :deep(.p-select) {
	display: flex;
	flex-direction: row;
	align-items: center;
	height: auto;
	flex: none;
}
.task-details-in-modal .taskDetailsRightBar :deep(.p-select-label) {
	width: auto !important;
	flex: 1 1 auto;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
}
.task-details-in-modal .taskDetailsRightBar > .m-3 {
	flex: 1;
	min-height: 0;
	display: flex;
	flex-direction: column;
	overflow: hidden;
	margin-right: 0;
	padding-right: 0;
}
.task-details-in-modal .thirtyWidthToggle {
	flex: 1;
	min-height: 0;
	height: auto !important;
	overflow-y: auto !important;
	scrollbar-width: thin;
	padding-right: 8px;
	box-sizing: border-box;
}
.task-details-in-modal .descriptionToggle::-webkit-scrollbar,
.task-details-in-modal .thirtyWidthToggle::-webkit-scrollbar {
	width: 6px !important;
	height: 6px !important;
	background: transparent;
}
.task-details-in-modal .descriptionToggle::-webkit-scrollbar-thumb,
.task-details-in-modal .thirtyWidthToggle::-webkit-scrollbar-thumb {
	background: #c4c4c4 !important;
	border-radius: 4px;
}
</style>
<script lang="ts">
import { defineComponent } from 'vue';
import breadCrumbs from '@/components/breadCrumbs.vue';
import { helpers, required, requiredIf } from '@vuelidate/validators';
import { useVuelidate } from '@vuelidate/core';
import popup from '@/components/popup.vue';
import tableData from '@/components/tableData.vue';
import pagination from '@/components/pagination.vue';
// import { groupBy } from 'lodash';
import { emitter, toast } from '@/main';
// import _ from 'lodash';
import moment from 'moment';
import { mapGetters } from 'vuex';
import { v4 as uuidv4 } from 'uuid';
import commentsEditor from '@/components/commentsEditor.vue';
import Multiselect from 'vue-multiselect';
import CommentsEditor from '@/components/commentsEditor.vue';
import safeHtml from '@/components/safeHtml.vue';
import dotsloader from '@/components/dotsloader.vue';
import Tabs from 'primevue/tabs';
import TabList from 'primevue/tablist';
import Tab from 'primevue/tab';
import TabPanels from 'primevue/tabpanels';
import TabPanel from 'primevue/tabpanel';
import AutoComplete from 'primevue/autocomplete';
import Select from 'primevue/select';
import EvidenceMultiSelect from 'primevue/multiselect';
const restrictCharacters1000 = helpers.regex(/^[\s\S]{0,1000}$/);
const httpUrl = (value: string) => {
	if (!value) return true;
	try {
		const parsed = new URL(value);
		return parsed.protocol === 'http:' || parsed.protocol === 'https:';
	} catch {
		return false;
	}
};
export default defineComponent({
	props: {
		subtaskId: { type: [String, Number], default: null },
		taskId: { type: [String, Number], default: null },
		modalMode: { type: Boolean, default: false },
	},
	emits: ['header-info'],
	data(): any {
		return {
			v$: useVuelidate(),
			selectedTabIndex: 1,
			fileToUpload: null,
			statuses:[],
			taskStatuses:[],
			subTaskStatuses:[],
			isRiskTask:false,
			riskData:[],
			userArray :[],
			tabHead: [
				{ displayName: 'Description', id: 1 },

				{ displayName: 'Documents', id: 2 },

				{ displayName: 'Evidence', id: 3 },

				{ displayName: 'Approvals', id: 4 },

				{ displayName: 'Comments', id: 5 },

				{ displayName: 'History', id: 6 }
			],
			selectedTabObj:{},
			dummySubTask:{},
			treatmentTypeStatus:[],
            clickOnButton: false,
			presentSubTask:[],
			dummyPresentSubTask:[],
			Headers: ['ccid','title','team','startDate','dueDate','SubTaskStatus'],
			tableRow:[],
			importpopUp: false,
			showDeleteEvidenceConfirm: false,
			deleteEvidenceIndex: null,
			linkEvidenceTasks: [],
			selectedExistingEvidences: [],
			selectedExistingFiles: [],
			selectedExistingLinks: [],
			linkEvidencePopup: false,
			existingEvidenceSortKey: '',
			existingEvidenceSortDir: 'asc',
			showExistingEvidenceFilters: false,
			existingEvidenceFilters: { filename: '', sourceTaskId: '', evidenceType: '', evidenceDate: '' },
			selectedLinkTask: null,
			inputFileName: '',
			dotsLoader:false,
			fileName:'',
			evidenceDate:'',
			evidenceAttachMode: 'file',
			evidenceUrl: '',
			linkSortKey: '',
			linkSortDir: 'asc',
			linkCurrentPage: 1,
			linkPageSize: 20,
			linkColumnNames: ['filename', 'url', 'evidenceDate'],
			linkColumnWidths: {},
			linkResizingColumn: null,
			linkResizeStartX: 0,
			linkResizeStartWidth: 0,
			linkDidResize: false,
			isInputFileNameValid: true,
			showSubTaskPopUp: false,
			controltitle:'',
			activitiesList:[],
			allProjects:[],
			TaskDetailsDropDown: {
				taskStatus: '',
				assignedToDropDown: ''
			},
			// controlFrequencyArray: [
			// 	{ label: 'Daily', id: 1 },
			// 	{ label: 'Weekly', id: 2 },
			// 	{ label: 'Monthly', id: 3 },
			// 	{ label: 'Quarterly', id: 4 },
			// 	{ label: 'Semi Annualy', id: 5 },
			// 	{ label: 'Annualy', id: 6 },
			// 	{ label: 'Transactional', id: 7 },
			// ],
			
			taskObj:{
				approver:'',
                approvalComments : ''
            },
			taskObjDummy:{
				approver:'',
                approvalComments : ''
			},
			userOptions:[],
			routesArray:[],
			allSubTasks:[],
			optionsProjectArray:[],
			users:[],
			showApprovalPopup: false,
			SubTaskStatus:[
                // {
				// 	id: 10411,
				// 	value: 'Draft'
				// },
				{
					id: 10401,
					value: 'Open'
				},
				{
					id: 10402,
					value: 'In Progress'
				},
				// {
				// 	id: 10415,
				// 	value: 'In Review'
				// },
				// {
				// 	id: 10403,
				// 	value: 'Completed'
				// },
			],
			failed:[
				{
					id: 10420,
					value: 'Failed'
				}
			],
			inreview:[
			{
					id: 10421,
					value: 'In Review'
				}
			],
			SubTaskStatus1:[
				// {
				// 	id: 10401,
				// 	value: 'Open'
				// },
				// {
				// 	id: 10402,
				// 	value: 'In Progress'
				// },
				// {
				// 	id: 10415,
				// 	value: 'In Review'
				// },
			],
			tasksStatus:[
				{
					id: 10411,
					value: 'Draft'
				},
				{
					id: 10401,
					value: 'Open'
				},
				{
					id: 10402,
					value: 'In Progress'
				},
				{
					id: 10421,
					value: 'In Review'
				},
				{
					id: 10403,
					value: 'Completed'
				},
			],
			subTaskDetailsObj:{},
			oldComments: true,
			newHistory: true,
			comment: '',
			comments: [],
			btnDisabled: true,
			selectedOption: '',
			selectedBG: '',
			workLogObject: [],
			optionsUserArray: [],
			orgUsersList: [],
			presentAuditObject: {},
			teamName: '',
			personObj : '',
			controlsArray : [],
			controlDetailsArray : [],
            controlsArrayAllControls : [],
            controlsDetailsList : [],
			teamObj : '',
			allFrameWorkControls:[],
			locationObject:[],
			fileSelected: false,
			isFileValid: true,
			fileChanged : false,
			findingsForTask:[],
			allActiveControls:[],
			teamObject:[],
			presentTemplateTask:[],
			mainTemplateTask:[],
			approvingMembers:[],
			titleLength: 0,
            controlTitleLength:0,
			placeholder: 'Select a File',
			searchValue:'',
			authorityOptions:[],
			linkedControlDetails:[],
			allProcess:[],
			optionsActivityArray:[],
			allSystems:[],
			optionSystemArray:[],
			showRejectPopupAtInReview : false,
			isRiskTaskReject: false,
			finalJustification:{
				justification : ''
			}
		};
	},
	validations() {
		return {
			inputFileName:{
				required,
				restrictCharacters50: function (this: any, value: string) {
					if (this.evidenceAttachMode !== 'file') return true;
					return String(value || '').length <= 50;
				}
			},
			fileToUpload: {
				required: requiredIf(function (this: any) {
					return this.evidenceAttachMode === 'file';
				})
			},
			evidenceUrl: {
				required: requiredIf(function (this: any) {
					return this.evidenceAttachMode === 'url';
				}),
				httpUrl
			},
			evidenceDate:{required},
			taskObj:{
				approver:{required},
				approvalComments:{required}
			},
			finalJustification:{
				justification : {restrictCharacters1000}
			},
		};
	},
	components: {
		breadCrumbs,
		popup,
		Multiselect,
		tableData,
		pagination,
		commentsEditor,
		safeHtml,
		dotsloader,
		Tabs,
		TabList,
		Tab,
		TabPanels,
		TabPanel,
		AutoComplete,
		Select,
		EvidenceMultiSelect
	},
	computed: {
		...mapGetters({ userInfo: 'userInfo',dbPriority: 'dbPriority',dbFrequency:'dbFrequency',dbLikelihood: 'dbLikelihood',dbOperations: 'dbOperations',
            dbLegal: 'dbLegal',
            dbFinancial: 'dbFinancial',
            dbTechnical: 'dbTechnical',dbBussiness: 'dbBussiness',dbOverAllImpact:'dbOverAllImpact'}),
		currentSubtaskId(): any {
			return this.subtaskId || this.$route.params.subtaskId;
		},
		currentParentTaskId(): any {
			return this.taskId || this.$route.params.taskId;
		},
		todayDate() {
			return new Date().toISOString().split('T')[0];
		},
		isEvidenceSaveDisabled(): boolean {
			if (this.evidenceAttachMode === 'url') {
				return this.inputFileName.length === 0 && this.evidenceUrl.length === 0 && this.evidenceDate.length === 0;
			}
			return this.inputFileName.length === 0 && this.evidenceDate.length === 0;
		},
		isEvidenceAttachDisabled(): boolean {
			return this.presentSubTask.statusCode == 10403
				|| this.presentSubTask.statusCode == 10420
				|| this.presentSubTask.statusCode == 10423
				|| this.presentSubTask.statusCode == 10410
				|| this.presentSubTask.statusCode == 10418
				|| this.isAddDisabled(10302);
		},
		linkTaskOptions(): any[] {
			const currentId = String(this.currentSubtaskId || '');
			const currentUrls = new Set((this.presentSubTask?.evidences || []).map((doc: any) => doc?.url).filter((url: any) => !!url));
			const userId = String(this.userInfo?._id || '');
			const options: any[] = [];
			(this.linkEvidenceTasks || []).forEach((task: any) => {
				if (String(task?._id || '') === currentId || !Array.isArray(task?.evidences)) return;
				const sourceTaskId = task.taskId != null && String(task.taskId) !== '' ? String(task.taskId) : '';
				if (!sourceTaskId) return;
				const hasEvidence = task.evidences.some((doc: any) => {
					if (!doc?.url || currentUrls.has(doc.url)) return false;
					if (String(doc.createdBy || '') !== userId) return false;
					return !!(doc.filename || doc.name);
				});
				if (!hasEvidence) return;
				options.push({ label: sourceTaskId, taskKey: String(task._id), sourceTaskId });
			});
			return options;
		},
		existingEvidenceOptions(): any[] {
			if (!this.selectedLinkTask?.taskKey) return [];
			const currentUrls = new Set((this.presentSubTask?.evidences || []).map((doc: any) => doc?.url).filter((url: any) => !!url));
			const userId = String(this.userInfo?._id || '');
			const task = (this.linkEvidenceTasks || []).find((item: any) => String(item?._id || '') === this.selectedLinkTask.taskKey);
			if (!task || !Array.isArray(task.evidences)) return [];
			const options: any[] = [];
			task.evidences.forEach((doc: any) => {
				if (!doc?.url || currentUrls.has(doc.url)) return;
				if (String(doc.createdBy || '') !== userId) return;
				const filename = doc.filename || doc.name;
				if (!filename) return;
				const sourceTaskId = doc.linkedEvidenceTaskId != null && String(doc.linkedEvidenceTaskId) !== ''
					? String(doc.linkedEvidenceTaskId)
					: (doc.taskId != null && String(doc.taskId) !== '' ? String(doc.taskId) : this.selectedLinkTask.sourceTaskId);
				options.push({
					...doc,
					filename,
					displayName: filename,
					sourceTaskId,
					optionKey: `${sourceTaskId}|${doc.url}`
				});
			});
			return options;
		},
		existingFileEvidenceOptions(): any[] {
			return this.existingEvidenceOptions.filter((doc: any) => (doc?.evidenceType || 'file') !== 'url');
		},
		existingLinkEvidenceOptions(): any[] {
			return this.existingEvidenceOptions.filter((doc: any) => doc?.evidenceType === 'url');
		},
		pastYearExistingEvidences(): any[] {
			const currentId = String(this.currentSubtaskId || '');
			const currentUrls = new Set((this.presentSubTask?.evidences || []).map((doc: any) => doc?.url).filter((url: any) => !!url));
			const userId = String(this.userInfo?._id || '');
			const now = new Date();
			const oneYearAgo = new Date();
			oneYearAgo.setFullYear(now.getFullYear() - 1);
			const rowsByUrl = new Map();
			const originalTaskByUrl = new Map();
			(this.linkEvidenceTasks || []).forEach((task: any) => {
				if (String(task?._id || '') === currentId || !Array.isArray(task?.evidences)) return;
				const plannerTaskId = task.taskId != null && String(task.taskId) !== '' ? String(task.taskId) : '';
				task.evidences.forEach((doc: any) => {
					if (!doc?.url || currentUrls.has(doc.url)) return;
					if (String(doc.createdBy || '') !== userId) return;
					const filename = doc.filename || doc.name;
					if (!filename) return;
					const evidenceTime = Date.parse(doc.evidenceDate);
					if (isNaN(evidenceTime) || evidenceTime < oneYearAgo.getTime() || evidenceTime > now.getTime()) return;
					const linkedTaskId = doc.linkedEvidenceTaskId != null && String(doc.linkedEvidenceTaskId) !== '' ? String(doc.linkedEvidenceTaskId) : '';
					if (linkedTaskId) {
						originalTaskByUrl.set(doc.url, linkedTaskId);
						return;
					}
					if (doc.taskId != null && String(doc.taskId) !== '' && plannerTaskId && String(doc.taskId) !== plannerTaskId) return;
					const taskMatches = doc.taskId != null && String(doc.taskId) !== '' && String(doc.taskId) === plannerTaskId;
					if (taskMatches && plannerTaskId && !originalTaskByUrl.has(doc.url)) {
						originalTaskByUrl.set(doc.url, plannerTaskId);
					}
					const sourceTaskId = doc.linkedEvidenceTaskId != null && String(doc.linkedEvidenceTaskId) !== ''
						? String(doc.linkedEvidenceTaskId)
						: (doc.taskId != null && String(doc.taskId) !== '' ? String(doc.taskId) : plannerTaskId);
					if (!sourceTaskId) return;
					const namedOriginal = originalTaskByUrl.get(doc.url);
					if (namedOriginal && plannerTaskId && plannerTaskId !== namedOriginal) return;
					const row = {
						...doc,
						filename,
						sourceTaskId,
						optionKey: `${sourceTaskId}|${doc.url}`
					};
					const existing = rowsByUrl.get(doc.url);
					if (!existing || (taskMatches && !existing.taskMatches) || (namedOriginal && plannerTaskId === namedOriginal && existing.plannerTaskId !== namedOriginal)) {
						rowsByUrl.set(doc.url, { row, taskMatches, plannerTaskId });
					}
				});
			});
			return Array.from(rowsByUrl.values()).filter((entry: any) => {
				const namedOriginal = originalTaskByUrl.get(entry.row.url);
				if (!namedOriginal || !entry.plannerTaskId) return true;
				return entry.plannerTaskId === namedOriginal;
			}).map((entry: any) => entry.row);
		},
		existingEvidenceSortClass(): string {
			return this.existingEvidenceSortDir === 'asc' ? 'sort_desc' : 'sort_asc';
		},
		filteredSortedExistingEvidences(): any[] {
			const filters = this.existingEvidenceFilters || {};
			const rows = (this.pastYearExistingEvidences || []).filter((row: any) => {
				const title = String(row.filename || '').toLowerCase();
				const taskId = String(row.sourceTaskId || '').toLowerCase();
				const typeLabel = String(this.getEvidenceTypeLabel(row)).toLowerCase();
				const dateLabel = row.evidenceDate ? String(this.formatFileAttachedTime(row.evidenceDate)).toLowerCase() : '';
				if (filters.filename && !title.includes(String(filters.filename).toLowerCase())) return false;
				if (filters.sourceTaskId && !taskId.includes(String(filters.sourceTaskId).toLowerCase())) return false;
				if (filters.evidenceType && !typeLabel.includes(String(filters.evidenceType).toLowerCase())) return false;
				if (filters.evidenceDate && !dateLabel.includes(String(filters.evidenceDate).toLowerCase())) return false;
				return true;
			});
			const key = this.existingEvidenceSortKey;
			if (!key) return rows;
			const modifier = this.existingEvidenceSortDir === 'desc' ? -1 : 1;
			return rows.sort((a: any, b: any) => {
				if (key === 'evidenceDate') {
					const aTime = Date.parse(a?.evidenceDate);
					const bTime = Date.parse(b?.evidenceDate);
					if (aTime < bTime) return -1 * modifier;
					if (aTime > bTime) return 1 * modifier;
					return 0;
				}
				if (key === 'sourceTaskId') {
					const aVal = String(a?.sourceTaskId || '');
					const bVal = String(b?.sourceTaskId || '');
					const aNumMatch = aVal.match(/\d+$/);
					const bNumMatch = bVal.match(/\d+$/);
					if (aNumMatch && bNumMatch) {
						const aNum = parseInt(aNumMatch[0], 10);
						const bNum = parseInt(bNumMatch[0], 10);
						if (aNum < bNum) return -1 * modifier;
						if (aNum > bNum) return 1 * modifier;
						return 0;
					}
					if (aVal < bVal) return -1 * modifier;
					if (aVal > bVal) return 1 * modifier;
					return 0;
				}
				const aVal = key === 'evidenceType' ? (a?.evidenceType === 'url' ? 'link' : 'file') : String(a?.filename || '');
				const bVal = key === 'evidenceType' ? (b?.evidenceType === 'url' ? 'link' : 'file') : String(b?.filename || '');
				if (aVal.toLowerCase() < bVal.toLowerCase()) return -1 * modifier;
				if (aVal.toLowerCase() > bVal.toLowerCase()) return 1 * modifier;
				return 0;
			});
		},
		pastYearFileEvidences(): any[] {
			return this.pastYearExistingEvidences.filter((doc: any) => (doc?.evidenceType || 'file') !== 'url');
		},
		pastYearLinkEvidences(): any[] {
			return this.pastYearExistingEvidences.filter((doc: any) => doc?.evidenceType === 'url');
		},
		fileEvidences(): any[] {
			const evidences = this.presentSubTask?.evidences;
			if (!Array.isArray(evidences)) return [];
			return evidences.filter((doc: any) => (doc?.evidenceType || 'file') !== 'url');
		},
		linkEvidences(): any[] {
			const evidences = this.presentSubTask?.evidences;
			if (!Array.isArray(evidences)) return [];
			return evidences.filter((doc: any) => doc?.evidenceType === 'url');
		},
		linkSortClass(): string {
			return this.linkSortDir === 'asc' ? 'sort_desc' : 'sort_asc';
		},
		sortedLinkEvidences(): any[] {
			const rows = [...this.linkEvidences];
			const key = this.linkSortKey;
			if (!key) {
				return rows;
			}
			const dir = this.linkSortDir === 'asc' ? 1 : -1;
			return rows.sort((a: any, b: any) => {
				let aVal = '';
				let bVal = '';
				if (key === 'evidenceDate') {
					aVal = a?.evidenceDate || '';
					bVal = b?.evidenceDate || '';
				} else if (key === 'url') {
					aVal = a?.url || '';
					bVal = b?.url || '';
				} else {
					aVal = a?.filename || a?.name || '';
					bVal = b?.filename || b?.name || '';
				}
				return String(aVal).localeCompare(String(bVal), undefined, { sensitivity: 'base' }) * dir;
			});
		},
		filteredLinkCount(): number {
			return this.sortedLinkEvidences.length;
		},
		paginatedLinkEvidences(): any[] {
			const start = (this.linkCurrentPage - 1) * this.linkPageSize;
			const end = this.linkCurrentPage * this.linkPageSize;
			return this.sortedLinkEvidences.slice(start, end);
		},
		linkTableResizeStyle(): any {
			return {
				tableLayout: 'fixed',
				width: '100%',
				maxWidth: '100%',
			};
		},
	},
	methods: {
		limitText (count:any) {
			// console.log('countcount',count)
		},
		getEvidenceOwnerName(doc: any): string {
			return this.getPersonName(doc?.createdBy, doc?.createdPersonName) || 'N/A';
		},
		resetLinkPagination() {
			this.linkCurrentPage = 1;
		},
		onLinkPaginationUpdate(currentPage: any, pageSize: any) {
			this.linkCurrentPage = currentPage;
			this.linkPageSize = pageSize;
		},
		linkColumnStyle(column: string) {
			const width = this.linkColumnWidths[column];
			if (!width) {
				return {};
			}
			return {
				width: width + 'px',
				minWidth: '60px',
				maxWidth: width + 'px',
			};
		},
		snapshotLinkColumnWidths() {
			const headers = this.$el?.querySelectorAll?.('.evidence-links-header thead th') || [];
			const names = this.linkColumnNames || [];
			headers.forEach((th: HTMLElement, index: number) => {
				const column = names[index];
				if (column && this.linkColumnWidths[column] == null) {
					this.linkColumnWidths[column] = Math.round(th.getBoundingClientRect().width);
				}
			});
		},
		getLinkContainerWidth() {
			const container = this.$el?.querySelector?.('.evidence-links-scroll') as HTMLElement | null;
			if (container) {
				return Math.max(60, Math.floor(container.clientWidth || container.getBoundingClientRect().width));
			}
			return window.innerWidth;
		},
		maxWidthForLinkColumn(column: string, proposedWidth: number) {
			const names = this.linkColumnNames || [];
			const otherWidth = names.reduce((sum: number, name: string) => {
				if (name === column) {
					return sum;
				}
				return sum + (Number(this.linkColumnWidths[name]) || 60);
			}, 0);
			const containerWidth = this.getLinkContainerWidth();
			const maxTotal = Math.max(60, containerWidth - otherWidth);
			return Math.min(proposedWidth, maxTotal, containerWidth);
		},
		clampLinkWidthsToContainer() {
			const names = this.linkColumnNames || [];
			if (!names.length || !Object.keys(this.linkColumnWidths || {}).length) {
				return;
			}
			const containerWidth = this.getLinkContainerWidth();
			const total = names.reduce((sum: number, name: string) => sum + (Number(this.linkColumnWidths[name]) || 0), 0);
			if (total <= containerWidth) {
				return;
			}
			const scale = containerWidth / total;
			const next: Record<string, number> = { ...this.linkColumnWidths };
			names.forEach((name: string) => {
				if (next[name]) {
					next[name] = Math.max(60, Math.round(next[name] * scale));
				}
			});
			let scaledTotal = names.reduce((sum: number, name: string) => sum + (Number(next[name]) || 0), 0);
			let overflow = scaledTotal - containerWidth;
			for (let i = names.length - 1; i >= 0 && overflow > 0; i--) {
				const name = names[i];
				const current = Number(next[name]) || 0;
				if (current > 60) {
					const reduced = Math.max(60, current - overflow);
					overflow -= current - reduced;
					next[name] = reduced;
				}
			}
			this.linkColumnWidths = next;
		},
		startLinkColumnResize(event: MouseEvent, column: string) {
			this.snapshotLinkColumnWidths();
			this.clampLinkWidthsToContainer();
			const th = (event.currentTarget as HTMLElement)?.closest('th');
			this.linkResizingColumn = column;
			this.linkResizeStartX = event.clientX;
			this.linkResizeStartWidth = this.linkColumnWidths[column] || th?.getBoundingClientRect().width || 60;
			this.linkDidResize = false;
			document.body.classList.add('col-resizing');
			document.addEventListener('mousemove', this.onLinkColumnResize);
			document.addEventListener('mouseup', this.stopLinkColumnResize);
		},
		onLinkColumnResize(event: MouseEvent) {
			if (!this.linkResizingColumn) {
				return;
			}
			const delta = event.clientX - this.linkResizeStartX;
			if (Math.abs(delta) > 2) {
				this.linkDidResize = true;
			}
			const nextWidth = this.maxWidthForLinkColumn(
				this.linkResizingColumn,
				Math.max(60, Math.round(this.linkResizeStartWidth + delta))
			);
			this.linkColumnWidths = { ...this.linkColumnWidths, [this.linkResizingColumn]: nextWidth };
		},
		stopLinkColumnResize() {
			this.linkResizingColumn = null;
			document.body.classList.remove('col-resizing');
			document.removeEventListener('mousemove', this.onLinkColumnResize);
			document.removeEventListener('mouseup', this.stopLinkColumnResize);
		},
		onLinkHeaderClick(column: string) {
			if (this.linkDidResize) {
				this.linkDidResize = false;
				return;
			}
			this.sortLinkEvidences(column);
		},
		sortLinkEvidences(key: string) {
			if (this.linkSortKey === key) {
				this.linkSortDir = this.linkSortDir === 'asc' ? 'desc' : 'asc';
			} else {
				this.linkSortKey = key;
				this.linkSortDir = 'asc';
			}
			this.resetLinkPagination();
		},
		getEvidenceFileExt(doc: any) {
			if (!doc?.url || doc.evidenceType === 'url') return '';
			try {
				const path = new URL(doc.url).pathname;
				return (path.split('.').pop() || '').toLowerCase();
			} catch {
				return (String(doc.url).split('.').pop() || '').toLowerCase();
			}
		},
		getEvidenceTypeLabel(doc: any) {
			if (doc?.evidenceType === 'url') return String(doc.evidenceType).toUpperCase();
			const ext = this.getEvidenceFileExt(doc);
			return ext ? ext.toUpperCase() : 'File';
		},
		onDragOver() {
		this.isDragOver = true;
		},

	onDragLeave() {
	this.isDragOver = false;
	},

	onFileDrop(event:any) {
	this.isDragOver = false;
	const file = event.dataTransfer?.files?.[0];
	if (file) {
		this.applySelectedFile(file);
	}
	},
	applySelectedFile(file:any) {
  this.fileName = file.name;
  this.fileToUpload = file;

  const fileNameParts = file.name.split('.');
  fileNameParts.pop();
  const nameWithoutExtension = fileNameParts.join('.');
  if (this.inputFileName.trim() === '') {
    this.inputFileName = nameWithoutExtension;
    if (nameWithoutExtension.length > 50) {
      this.v$.inputFileName.$touch();
    }
  }

  // const fileExtension = file.name.split('.').pop();
  const fileExtension = file.name.split('.').pop()?.toLowerCase();
  if (
    fileExtension == 'pdf' || fileExtension == 'docx' || fileExtension == 'xls' ||
    fileExtension == 'xlsx' || fileExtension == 'jpeg' || fileExtension == 'png' ||
    fileExtension == 'jpg' || fileExtension == 'mp4' || fileExtension == 'doc' ||
    fileExtension == 'rtf' || fileExtension == 'txt' || fileExtension == 'csv' ||
    fileExtension == 'zip' || fileExtension == 'ods'
  ) {
    this.pdfValidation = false;
    this.v$.$reset();
  } else {
    this.pdfValidation = true;
  }
},

	handleFileUpload(event:any) {
	const file = event?.target?.files?.[0];
	if (file) {
		this.applySelectedFile(file);
	} else {
		this.fileName = '';
		this.inputFileName = '';
	}
	},
		 clearSelectedFile() {
			this.fileName=''
			this.fileToUpload = '';
			this.pdfValidation = false;
			this.v$.$reset();

			if (this.$refs.fileInput) {
				this.$refs.fileInput.value = '';
			}
		},
		formatFileAttachedTime(time: any) {    
			let now = moment(time);
			return now.format("DD-MM-YYYY");
		},
		presentTask(dataInfo: any) {
			const item = this.treatmentTypeStatus.find((data: any) => data.id == dataInfo);
			return item ? item.label : 'N/A';
		},
		openCalendar(event: any) {
			event.target.showPicker();
		},
		treatmentSummaryData(actionType:any){
			if(actionType!='' && actionType==10424){
				if(this.presentSubTask.riskInformation.transferSummary && this.presentSubTask.riskInformation.transferSummary!=undefined){
					return this.presentSubTask.riskInformation.transferSummary
				}
				else{
					return 'N/A'
				}
			}
			else if(actionType!='' && actionType==10419){
				if(this.presentSubTask.riskInformation.avoidSummary && this.presentSubTask.riskInformation.avoidSummary!=undefined){
					return this.presentSubTask.riskInformation.avoidSummary
				}
				else{
					return 'N/A'
				}
			}
			else if(actionType!='' && actionType==10403){
				if(this.presentSubTask.riskInformation.acceptSummary && this.presentSubTask.riskInformation.acceptSummary!=undefined){
					return this.presentSubTask.riskInformation.acceptSummary
				}
				else{
					return 'N/A'
				}
			}
			else if(actionType!='' && actionType==10425){
				if(this.presentSubTask.riskInformation.moniteredSummary && this.presentSubTask.riskInformation.moniteredSummary!=undefined){
					return this.presentSubTask.riskInformation.moniteredSummary
				}
				else{
					return 'N/A'
				}
			}
			else{
				return 'N/A'
			}
			
		},
		 colorRiskBg(value: any) {
            if (value == 1) {
                return ['bg-veryLowColor border-solid border border-lightgreen'];
            } else if (value == 2) {
                return ['bg-lowColor border-solid border border-green'];
            } else if (value == 3) {
                return ['bg-moderateColor border-solid border border-yellow'];
            } else if (value == 4) {
                return ['bg-highColor border-solid border border-error'];
            } else if (value == 5) {
                return ['bg-veryHighColor border-solid border border-darkred'];
            }
        },
        colorRiskText(value: any) {
            if (value == 1) {
                return ['text-lightgreen font-semibold text-xs'];
            } else if (value == 2) {
                return ['text-green font-semibold text-xs'];
            } else if (value == 3) {
                return ['text-yellow font-semibold text-xs'];
            } else if (value == 4) {
                return ['text-error font-semibold text-xs'];
            } else if (value == 5) {
                return ['text-darkred font-semibold text-xs'];
            }
        },
		isAddDisabled(permission:any) {
            try {
                if (this.userInfo.organisationType !== 10701) {
                    return false; // or true if you want to disable for others
                }
				
                return !this.hasPermission(this.userInfo, 10007, 10117, permission);
            } catch (e) {
                console.error("Permission check failed:", e);
                return true; // safest fallback = disable the button
            }
	    },
		onCancelbtnForFinalApproval(){
			// this.onCrossBtnForFinalApproval();
			this.finalJustification.justification = '';
		},
		onCrossBtnForFinalApproval(){
			this.showRejectPopupAtInReview = false;
			this.isRiskTaskReject = false;
			this.finalJustification.justification = '';
		},
		onClickToRejectByJustificationAtInReview(){
		this.finalJustification.justification = '';
		this.isRiskTaskReject = false;
		this.showRejectPopupAtInReview = true;
		},
		async confirmRiskTaskReject(){
			if(this.finalJustification.justification == ''){
				return;
			}
			this.clickOnButton = true;
			try {
				await this.updateTemplateTask(5, {
					statusCode: 10410,
					justification: this.finalJustification.justification
				});
				this.showRejectPopupAtInReview = false;
				this.isRiskTaskReject = false;
				this.finalJustification.justification = '';
			} finally {
				this.clickOnButton = false;
			}
		},
		
		getRiskOwnerLabel(userId:any) {

			const user = this.optionsUserArray.find(
				(u: any) => u.value === userId
			);

			return user ? user.label : 'N/A';
		},
		getLablesInfo(data:any,id:any){
			if(id==1){
				let a = this.dbBussiness.find((obj: any) =>{
			  return obj.value == data});
              return (data && typeof data === 'number') ? a.key : '';
			}
			if(id==2){
				let a = this.dbFinancial.find((obj: any) =>{
			  return obj.value == data});
              return (data && typeof data === 'number') ? a.key : '';
			}
			if(id==3){
				let a = this.dbOperations.find((obj: any) =>{
			  return obj.value == data});
              return (data && typeof data === 'number') ? a.key : '';
			}
			if(id==4){
				let a = this.dbLegal.find((obj: any) =>{
			  return obj.value == data});
              return (data && typeof data === 'number') ? a.key : '';
			}if(id==5){
				let a = this.dbLikelihood.find((obj: any) =>{
			  return obj.value == data});
              return (data && typeof data === 'number') ? a.key : '';
			}
			if(id==6){
				let a = this.dbOverAllImpact.find((obj: any) =>{
			  return obj.value == data});
              return (data && typeof data === 'number') ? a.key : '';
			}
		},
		isAddApprovalDisabled(permission:any) {
            try {				
                if (this.userInfo.organisationType !== 10701 && (this.userInfo._id==this.presentSubTask.assignee.value || this.userInfo.roleId!=10217)) {

                    return false; // or true if you want to disable for others
                }
				
                return !this.hasPermission(this.userInfo, 10007, 10117, permission);
            } catch (e) {
                console.error("Permission check failed:", e);
                return true; // safest fallback = disable the button
            }
	    },
        hasPermission(userInfo:any, appId:any, entityId:any, permissionId:any) {
		if (!userInfo || !userInfo.apps) return false;

		const app = userInfo.apps.find((a:any) => a.appId === appId);
		if (!app) return false;

		const entity = app.entities?.find((e:any) => e.entityId === entityId);
		if (!entity) return false;
		
		return entity.permissions?.includes(permissionId) || false;
	    },
		changeDateFormat(date: any) {
            if(date != undefined){
                return date.split('-').reverse().join('-');
            }
		},
		async updateDate(updatedDate:any,type:any){
            let now = new Date();
            let selectedDate = new Date(updatedDate);
            selectedDate.setHours(
                now.getHours(),
                now.getMinutes(),
                now.getSeconds(),
                now.getMilliseconds()
            );
            if(type==20604){
                let payload: any = { startDate: selectedDate};
                await this.updateTemplateTask(8,payload,type)
            }
            if(type==20605){
                let payload: any = { endDate: selectedDate};
                await this.updateTemplateTask(8,payload,type)
            }
 
        },
		async approveOrRejectForActionTasktoComplete(statusCode: any, typeId: any) {
			this.clickOnButton = true;
			let subtaskId: any = this.currentSubtaskId
			const payload: any={
				statusCode: statusCode,
				updatedBy: this.userInfo._id,
				justification:this.finalJustification.justification
			}
			// /api/org/task/:taskId/update/approval

			// POST

			// => payload for approving approval

			// {statusCode: 10403 , updatedBy:'',updatedAt:''}
			await this.$http.post(`${process.env.VUE_APP_PLANNER_API}/api/org/task/${subtaskId}/update/approval`,payload).then((res: any) => {
                
				// console.log("this.presentSubTask",this.presentSubTask)
            });
			if(statusCode == 10403){
                toast.success(`Approval Approved`, {
						timeout: 1000,
						closeOnClick: true,
						closeButton: 'button',
						icon: true
				});
				await this.getSubTaskHistoryObject()
            }else if(statusCode == 10410){
				this.showRejectPopupAtInReview = false;
                toast.error(`Approval Rejected`, {
						timeout: 1000,
						closeOnClick: true,
						closeButton: 'button',
						icon: true
				});
				this.clickOnButton = false;
				await this.getSubTaskHistoryObject() 
            }
			await this.getPresentSubTask();
			},
		getTargetTitle(data:any){
			if (data.activityId) {
				let Title = 'Activity';
				return Title
			} else if (data.systemId) {
				let Title = 'System';
				return Title
			}else if (data.projectId) {
				let Title = 'Project';
				return Title
			}else {
				return 'N/A'
			}
		},
		getTargetInfo(data:any){
			if(data.activityId){
				let activity = this.optionsActivityArray.find((activity:any)=>data.activityId.toString()== activity.value.toString());
				return activity!=undefined?activity.label:'N/A'
			}
			else if(data.systemId) {
				let System = this.optionSystemArray.find((sys:any)=>data.systemId.toString()== sys.value.toString());
				return System!=undefined?System.label:'N/A'			
			}
			else if(data.projectId) {
				let System = this.optionsProjectArray.find((sys:any)=>data.projectId.toString()== sys.value.toString());
				return System!=undefined?System.label:'N/A'			
			}
			else{
				return 'N/A'
			}
		},
		getUserteamName(data:any){
			// let users =this.orgUsersList.find((u:any)=>u._id.toString() == data?.value);
			if(data!=undefined){
				if(data!=undefined){					
					let d = this.teamObject.find((dept:any)=>dept.value.toString()==data.toString());					
					 return d?d.label:'N/A'
				}
				else{
					return 'N/A'
				}
				// return users.departmentId
			}
			else{
				return 'N/A'
			}
		},
		asyncFind(query:any){
			query=query.query
			this.searchValue = query;
			if(query == ''){
				this.userOptions = []
			}else if(query.length > 0){
				this.userOptions = this.optionsUserArray.filter((obj:any)=>{return (obj.label.toLowerCase().includes(query.toLowerCase())&&this.dummyPresentSubTask?.assignee?.value!=obj.value)})
			}
		},
		asyncFind1(query:any){
			query=query.query;
			this.searchValue = query;
			if(query == ''){
				this.authorityOptions = []
			}else if(query.length > 0){
				this.authorityOptions = this.approvingMembers?.filter((obj:any)=>{return obj.label.toLowerCase().includes(query.toLowerCase()) && obj.value != this.userInfo._id})
			}
		},
		async getSubTaskHistoryObject() {
			// /api/org/task/:taskId/history/get
			
			// for task history
			await this.$http.get(`${process.env.VUE_APP_PLANNER_API}/api/org/task/${this.currentSubtaskId}/history/get`).then((result: any) => {
				const mainObject = result.data;
				this.workLogObject = mainObject;
				// if(this.workLogObject.taskHistory && this.workLogObject.taskHistory.length != 0){
				// 	this.workLogObject.taskHistory.sort().reverse();
				// }
			});
		},
		
		async fetchActivitiesList() {
		await this.$http.get(`${process.env.VUE_APP_CONTROLS_API}/api/org/processes/mappedcontrols/count`).then((res: { data: any }) => {
			this.activitiesList = res.data;
		});
		},
		async getAllProjects(){
			this.projectDataArray = [],
			await this.$http.get(`${process.env.VUE_APP_ORG_API}/api/org/projects/getAll`).then((res: any) => {
				this.allProjects = res.data;
				for (var i = 0; i < this.allProjects.length; i++) {
					this.optionsProjectArray.push({ label: this.allProjects[i].projectName, value: this.allProjects[i]._id });
				}
		})},
		
		getLocation(teamId:any){
                
			let presentteamObject:any = this.users.find((obj: any) => {
				return obj._id == teamId;
			});

			if (presentteamObject!=undefined && presentteamObject.type == 20301){
				return 'Global';
			}else{
				if(this.presentSubTask.location == undefined || this.presentSubTask.location == null ){
					return 'N/A'
				}else{
					return this.getLocationName(this.presentSubTask.location[0].entity)
				}
			}
		},
		getLocationName(locationId: any) {
            let locationObj = this.locationObject.find((obj: any) => {
                return obj.value == locationId;
            });
			
            if (locationObj == undefined) {
                let empty = '';
                return empty;
            } else {
                return locationObj.label;
            }
        },
		sanitizeUrl(rawUrl: any) {
			if (typeof rawUrl !== 'string') {
				return '#';
			}
			const trimmed = rawUrl.trim();
			const lower = trimmed.toLowerCase();
			// Block dangerous schemes
			if (lower.startsWith('javascript:') || lower.startsWith('data:') || lower.startsWith('vbscript:')) {
				return '#';
			}
			// Allow http(s) and common relative URLs
			if (/^(https?:\/\/|\/|\.{1,2}\/)/.test(trimmed)) {
				return trimmed;
			}
			return '#';
		},
		getS3KeyFromUrl(fileUrl: string) {
			// https://crystalnikhil.s3.amazonaws.com/planner/uuid.pdf
			// → planner/uuid.pdf
			try {
				const url = new URL(fileUrl);
				return url.pathname.startsWith('/')
				? url.pathname.slice(1)
				: url.pathname;
			} catch (e) {
				return '';
			}
			},

			async openEvidenceFile(doc: any) {
			const fileUrl = typeof doc === 'string' ? doc : doc?.url;
			if (!fileUrl) return;

			if (typeof doc !== 'string' && doc?.evidenceType === 'url') {
				window.open(fileUrl, '_blank', 'noopener,noreferrer');
				return;
			}

			const key = this.getS3KeyFromUrl(fileUrl);
			if (!key) {
				return;
			}

			try {
				const response = await this.$http.post(
				`${process.env.VUE_APP_FILE_API}/presignedurl/v3`,
				{ key } // bucket comes from AWS_BUCKET_NAME on server
				);

				const signedUrl =
				typeof response.data === 'string'
					? response.data
					: response.data?.url;

				if (signedUrl) {
				window.open(signedUrl,'_Self', 'noopener,noreferrer');
				}
			} catch (err) {
				console.error(err);
				// optional: toast.error('Unable to open file');
			}
		},
		openDeleteEvidenceConfirm(evidenceIndex: number) {
			this.deleteEvidenceIndex = evidenceIndex;
			this.showDeleteEvidenceConfirm = true;
		},
		cancelDeleteEvidence() {
			this.showDeleteEvidenceConfirm = false;
			this.deleteEvidenceIndex = null;
		},
		async confirmDeleteEvidence() {
			const evidenceIndex = this.deleteEvidenceIndex;
			this.showDeleteEvidenceConfirm = false;
			this.deleteEvidenceIndex = null;
			if (evidenceIndex == null) return;
			await this.removeEvidence(evidenceIndex);
		},
		async removeEvidence(evidenceIndex: number) {
			const evidence = this.presentSubTask?.evidences?.[evidenceIndex];
			const url = evidence?.url;
			const isUrlEvidence = evidence?.evidenceType === 'url';
			const statusCode = this.presentSubTask?.statusCode;
			if (statusCode == 10403 || statusCode == 10420 || statusCode == 10418) {
				return;
			}
			try {
				let urlStillUsed = false;
				if (!isUrlEvidence && url) {
					const tasksResponse = await this.$http.get(`${process.env.VUE_APP_PLANNER_API}/api/org/tasks/getAll`);
					const tasks = Array.isArray(tasksResponse?.data) ? tasksResponse.data : [];
					const currentId = String(this.currentSubtaskId || '');
					urlStillUsed = tasks.some((task: any) => String(task?._id || '') !== currentId && Array.isArray(task?.evidences) && task.evidences.some((doc: any) => doc?.url === url));
				}
				if (!isUrlEvidence && url && !urlStillUsed) {
					const fileResponse = await this.$http.post(`${process.env.VUE_APP_FILE_API}/bucket/file/delete`, { url });
					if (!(fileResponse.status == 200 && fileResponse.data?.deleted === true)) {
						return;
					}
				}
				await this.$http.post(
					`${process.env.VUE_APP_PLANNER_API}/api/org/task/${this.currentSubtaskId}/evidence/remove`,
					{ evidenceIndex, createdBy: this.userInfo._id }
				);
				await this.getPresentSubTask();
				await this.getSubTaskHistoryObject();
			} catch (err) {
				toast.error(`Failed to remove evidence`, {
					timeout: 1000,
					closeOnClick: true,
					closeButton: 'button',
					icon: true
				});
			}
		},
		onCancelIcon(){
			this.importpopUp = false
			this.inputFileName = ''
			this.fileName = '',
			this.evidenceDate='',
			this.fileToUpload=null
			this.evidenceUrl = ''
			this.evidenceAttachMode = 'file'
			this.selectedExistingEvidences = []
			this.v$.$reset();
		},
		getStatusLabel(num:any){
			let result:any;
				result = this.statuses.find((obj:any)=>{return obj.id == num});	
			if(result==undefined){
					result = this.statuses.find((obj:any)=>{return obj.id == num});	
			}
			// let resultValue = result.value
			return result?.label ||'N/A'
		},
		scrollTabIntoView(tabId : any) {
			this.$nextTick(() => {
				const tabElement = this.$el.querySelector(`.tab:nth-child(${tabId})`);
				if (tabElement) {
				tabElement.scrollIntoView({ behavior: 'smooth', inline: 'center' });
				}
			});
		},
		openApprovalpopup(){
			this.showApprovalPopup = true
		},
		onCancelbtnAtApproval(){
			this.v$.$reset();
			this.taskObj.approver = ''
			this.taskObj.approvalComments = ''
		},
		onCrossbtn(){
			this.v$.$reset();
			this.taskObj.approver = ''
			this.taskObj.approvalComments = ''
			this.showApprovalPopup =  false
		},
		checkOwner(){
			let approver: any 
			if(this.presentSubTask.approvals){
				let approvals: any = this.presentSubTask.approvals
				approvals.forEach((obj:any) => {
					approver = obj.approver
				});
				if(this.userInfo.organisationType==10701 && this.userInfo.role_id!=10217){
					return true;
				}
				if(approver == this.userInfo._id || this.userInfo.roleId!=10217){
					return true
				} else{
					return false
				}
			}
		},
		async getAllActiveControls(){
			await this.$http
			.get(`${process.env.VUE_APP_CONTROLS_API}/api/org/controls/active`)
			.then((result: { data: any }) => {
				this.allActiveControls = result.data;
			}).catch((error: any) => {
				toast.error(` ${error}`, {
					timeout: 1000,
					closeOnClick: true,
					closeButton: 'button',
					icon: true
				});
			});
        },
		clickOnSaveForApproval(obj: any){
			// (TYPE = 3) for sending approvals
			// {approver:'userId',createdBy:'',createdAt:''}
			let payload: any = {
				approver :obj.approver.value,
				justification:obj.approvalComments
			}
			this.v$.$touch();
			if(!this.v$.taskObj.$invalid){
				this.clickOnButton = true;
			this.updateTemplateTask(3,payload)
			this.getPresentSubTask();
			// this.taskObjDummy = this.taskObj
			this.showApprovalPopup = false
			this.taskObj.approver = ''
			this.taskObj.approvalComments = ''
			this.v$.$reset();
			this.clickOnButton = false;
			}
		},
		async approveOrRejectTheParentApproval(statusCode: any){
			this.clickOnButton = true;
			let subtaskId: any = this.currentSubtaskId
			const payload: any={
				statusCode: statusCode,
				updatedBy: this.userInfo._id
			}
			// /api/org/task/:taskId/update/approval

			// POST

			// => payload for approving approval

			// {statusCode: 10403 , updatedBy:'',updatedAt:''}
			await this.$http.post(`${process.env.VUE_APP_PLANNER_API}/api/org/task/${subtaskId}/update/approval`,payload).then((res: any) => {
                
				// console.log("this.presentSubTask",this.presentSubTask)
            });
			if(statusCode == 10403){
                toast.success(`Approval Approved`, {
						timeout: 1000,
						closeOnClick: true,
						closeButton: 'button',
						icon: true
				});
				await this.getSubTaskHistoryObject()
            }else if(statusCode == 10410){
                toast.error(`Approval Rejected`, {
						timeout: 1000,
						closeOnClick: true,
						closeButton: 'button',
						icon: true
				});
				this.clickOnButton = false;
				await this.getSubTaskHistoryObject() 
            }
			await this.getPresentSubTask();
			// this.workLogObject.taskHistory?.sort().reverse();
		},
		async getAllActiveUsers() {
			await this.$http.get(`${process.env.VUE_APP_ORG_API}/users/active/getall`).then((res: any) => {
				this.orgUsersList = res.data;
				for (var i = 0; i < this.orgUsersList.length; i++) {
					this.optionsUserArray.push({ label: this.orgUsersList[i].name, value: this.orgUsersList[i]._id });

					if(this.userInfo._id != this.orgUsersList[i]._id){
						this.approvingMembers.push({ label: this.orgUsersList[i].name, value: this.orgUsersList[i]._id });
					}
				}
			});
		},
		
		async getallEntities() {
            this.locationObject = []
			let result:any
            await this.$http.get(`${process.env.VUE_APP_ORG_API}/api/org/businessEntities/getall`).then((res: any) => {
                result = res.data;
            });
            for (var i = 0; i < result.length; i++) {
                this.locationObject.push({ label: result[i].entityDisplayName, value: result[i]._id });
            }
        },
		async getAllTeams() {
            this.teamObject = []
            await this.$http.get(`${process.env.VUE_APP_ORG_API}/departments/get`).then((res: any) => {
                this.users = res.data;
            });
            
            for (var i = 0; i < this.users.length; i++) {
                this.teamObject.push({ label: this.users[i].displayName, value: this.users[i]._id });
            }
            
        },
		async getAllBusinessProcesses() {
            await this.$http.get(`${process.env.VUE_APP_ORG_API}/api/org/getall/${20006}`).then((result: any) => {
				this.allProcess = result.data
            });
			for(let i=0;i<this.allProcess.length;i++){
				this.optionsActivityArray.push({ label: this.allProcess[i].businessProcessName, value: this.allProcess[i]._id });
			}
		},
		async getAllSystems(){
			await this.$http.get(`${process.env.VUE_APP_ORG_API}/api/org/getall/${20005}`).then((result: any) => {
				this.allSystems = result.data;
				// this.orgUsersList = res.data
				for (var i = 0; i < this.allSystems.length; i++) {
					this.optionSystemArray.push({ label: this.allSystems[i].systemName, value: this.allSystems[i]._id });
				}
			});
		},
		getPersonName(person: any,personName:any) {        
            let personObj = this.orgUsersList.find((user: any) => {            
                return user._id == person;
            });        
           
            if (personObj == undefined && person==undefined) {
                return '';
            } else if(person!=undefined && personObj==undefined){                              
                if(this.userInfo._id==person){                  
                    return this.userInfo.name;
                }
                else{
                    if(personName!=undefined && personObj==undefined && person!=undefined){
                        return personName;
                    }
                    return 'N/A';
                }
            }else {
                return personObj.name;
            }
        },
		getPerson(person: any) {
			this.personObj = this.orgUsersList.find((user: any) => {
				return user._id == person;
			});
			if (this.personObj == undefined) {
				return '';
			} else {
				return this.personObj.name;
			}
		},
		sortWorkLog() {
			this.newHistory = !this.newHistory;
			this.workLogObject.taskHistory?.sort().reverse();
		},
		sortComments() {
			this.oldComments = !this.oldComments;
			if(this.presentSubTask.comments != undefined){
				this.presentSubTask.comments.sort().reverse();
			}
		},
		formatTime(time: any) {
			let now = moment(time);
			return now.format('DD-MM-YYYY, HH:mm:ss');
		},
		formatDate(date:any) {
		if(date==undefined || date==''){
			return 'N/A'
		}
			let now = moment(date);
			return now.format('DD-MM-YYYY');
		},
		extractInitials(name: any) {
			if(name!=undefined){
			const names = name.split(" ");
			return names
			.map((name: any) => name[0])
			.join("")
			.toUpperCase();

			}
			else{
				return '';
			}
			
		},
		changeBackground() {
			if (this.TaskDetailsDropDown.taskStatus == 10411) {
				return 'bg-disabledgrey textColorWhite';
			} else if (this.TaskDetailsDropDown.taskStatus == 10415 || this.TaskDetailsDropDown.taskStatus == 10421) {
				return 'bg-yellow textColorWhite';
			} else if (this.TaskDetailsDropDown.taskStatus == 10402) {
				return 'bg-electricGreen textColorWhite';
			} else if (this.TaskDetailsDropDown.taskStatus == 10403 || this.TaskDetailsDropDown.taskStatus == 10423) {
				return 'bg-lightgreen textColorWhite';
			} else if (this.TaskDetailsDropDown.taskStatus == 10401) {
				return 'bg-primary textColorWhite';
			}else if (this.TaskDetailsDropDown.taskStatus == 10420) {
				return 'bg-darkred textColorWhite';
			} else if (this.TaskDetailsDropDown.taskStatus == 10410) {
				return 'bg-darkred textColorWhite';
			} else if(this.TaskDetailsDropDown.taskStatus == 10418) {
				return 'bg-error textColorWhite';
			}
			else {
				return '';
			}
		},
		checkAuditor(id:any){
			if(id == this.userInfo._id){
				return true
			} else if(id == undefined || id == null){
				return false
			} else {
				return false
			}
		},
		async updateTaskStatus(status: any) {          
            if(this.presentSubTask!=undefined && this.presentSubTask.statusCode!=undefined && status!=undefined && this.presentSubTask.statusCode==status) {
                return;
            }
            let payload: any = { statusCode: status };
            if(status == 10403 || status == 10423 || status == 10410){                                
                let hasCompletedAt = (
                    this.presentSubTask!=undefined &&
                    this.presentSubTask.completedAt != undefined &&
                    this.presentSubTask.completedAt != ""
                );
                let hasEvidence = (
                    this.presentSubTask.evidences != undefined &&
                    this.presentSubTask.evidences != null &&
                    this.presentSubTask.evidences.length > 0
                );
                if(!hasCompletedAt && !hasEvidence){
                    this.$nextTick(() => {
                        this.TaskDetailsDropDown.taskStatus = this.presentSubTask.statusCode;
                    });
                    toast.error(`Add Evidence and Completion Date`, {
                        timeout: 3000,
                        closeOnClick: true,
                        closeButton: "button",
                        icon: true,
                    });
                    return;
                }
                if(!hasCompletedAt){
                    this.$nextTick(() => {
                        this.TaskDetailsDropDown.taskStatus = this.presentSubTask.statusCode;
                    });
                    toast.error(`Add Completion Date`, {
                        timeout: 3000,
                        closeOnClick: true,
                        closeButton: "button",
                        icon: true,
                    });
                    return;
                }
                if(!hasEvidence){
                    this.$nextTick(() => {
                        this.TaskDetailsDropDown.taskStatus = this.presentSubTask.statusCode;
                    });
                    toast.error(`Add Evidence`, {
                        timeout: 3000,
                        closeOnClick: true,
                        closeButton: "button",
                        icon: true,
                    });
                    return;
                }
 
                if(hasEvidence && hasCompletedAt){
                    if(status == 10410 && this.presentSubTask.hasOwnProperty('linkedRiskId') && this.presentSubTask.treatmentType != 10405){
                        this.$nextTick(() => {
                            this.TaskDetailsDropDown.taskStatus = this.presentSubTask.statusCode;
                        });
                        this.finalJustification.justification = '';
                        this.isRiskTaskReject = true;
                        this.showRejectPopupAtInReview = true;
                        return;
                    }
                    await this.updateTemplateTask(5,payload)
                }
            }
            else {
                await this.updateTemplateTask(5, payload);
            }
        },
		async updateAssignedMember(obj: any) {
			let payload: any = { assignee: obj.value };
			await this.updateTemplateTask(6,payload)
		},
		async updateCompletionDate(obj:any) {
			let payload:any= {completedAt: obj };
			await this.updateTemplateTask(8,payload);
		},
		handleInput() {
			this.btnDisabled = this.comment.length === 0;
		},
		async addComment() {
			if (this.comment.trim() !== '') {
				const newComment: any = {
					comment: this.comment
				};
				await this.updateTemplateTask(4, newComment);
				
				// if(this.presentSubTask.comments != undefined){
				// 	this.presentSubTask.comments.sort().reverse();
				// }
				this.comment = '';
				this.btnDisabled = true;
			}
		},
		clearComment() {
			this.comment = '';
			this.btnDisabled = true;
		},
		async toggleTabs(obj: any) {
			this.dotsLoader=true
			this.scrollTabIntoView(obj.id);
			this.selectedTabIndex = obj.id;
			this.selectedTabObj = obj;
			// sessionStorage.setItem('selectedTab',obj.id);			
			await this.getPresentSubTask();
			
			await this.getSubTaskHistoryObject();
		},
		colorLabelText(value: any) {
            if (value == 1) {
                return ["text-lightgreen font-semibold"];
            } else if (value == 2) {
                return ["text-green font-semibold"];
            } else if (value == 3) {
                return ["text-yellow font-semibold"];
            } else if (value == 4) {
                return ["text-error font-semibold"];
            } else if (value == 5) {
                return ["text-darkred font-semibold"];
            }
        },
        colorLabelBg(value: any) {
            if (value == 1) {
                return ["bg-veryLowColor border-solid border border-lightgreen"];
            } else if (value == 2) {
                return ["bg-lowColor border-solid border border-green"];
            } else if (value == 3) {
                return ["bg-moderateColor border-solid border border-yellow"];
            } else if (value == 4) {
                return ["bg-highColor border-solid border border-error"];
            } else if (value == 5) {
                return ["bg-veryHighColor border-solid border border-darkred"];
            }
        },
		treatmentTypeBgColor(id:any){
			if(id==10403){
				return ["bg-veryLowColor border-solid border border-lightgreen"];
			}
			else if(id ==10419){
				 return ["bg-lowColor border-solid border border-green"];
			}
			else if(id==10405){
				return  ['bg-veryLowColor border-solid border border-lightgreen'];
			}
			else if(id==10424){
				return ["bg-moderateColor border-solid border border-yellow"];
			}
			else if(id==10425){
				return ["bg-resetBlue/10 border-solid border border-resetBlue"];
			}
		},
		treatmentTypeTextColor(id:any){
			if(id==10403){
				return ["text-lightgreen font-semibold"];
			}
			else if(id ==10419){
				  return ["text-green font-semibold"];
			}
			else if(id ==10405){
				return ['text-lightgreen font-semibold'];
			}
			else if(id==10424){
				return ["text-yellow font-semibold"];
			}
			else if(id==10425){
				return ["text-resetBlue font-semibold"];
			}
		},
        getProirityLabel(val:any){
          if (val === 'N/A') { 
              return ''; 
          } else {
              let a = this.dbPriority.find((obj: any) =>{
			  return obj.value == val});
              return (val && typeof val === 'number') ? a.key : '';
          }

        },
		onCancelButtonAddPopUp() {
			this.showSubTaskPopUp = false;
			this.onCancelbtn();
		},
		openFilePopup(mode: string = 'file') {
			this.evidenceAttachMode = mode === 'url' ? 'url' : 'file'
			this.evidenceUrl = ''
			this.fileName = ''
			this.fileToUpload = null
			this.pdfValidation = false
			this.inputFileName = ''
			this.evidenceDate = ''
			this.v$.$reset()
			this.importpopUp = true
		},
		async loadExistingFileOptions() {
			try {
				const res = await this.$http.get(`${process.env.VUE_APP_PLANNER_API}/api/org/tasks/getAll`);
				this.linkEvidenceTasks = Array.isArray(res?.data) ? res.data : [];
			} catch (error) {
				this.linkEvidenceTasks = [];
				toast.error(`Failed to load tasks`, {
					timeout: 1000,
					closeOnClick: true,
					closeButton: 'button',
					icon: true
				});
			}
		},
		resetExistingEvidenceTable() {
			this.existingEvidenceSortKey = '';
			this.existingEvidenceSortDir = 'asc';
			this.showExistingEvidenceFilters = false;
			this.existingEvidenceFilters = { filename: '', sourceTaskId: '', evidenceType: '', evidenceDate: '' };
		},
		toggleExistingEvidenceFilters() {
			this.showExistingEvidenceFilters = !this.showExistingEvidenceFilters;
			if (!this.showExistingEvidenceFilters) {
				this.existingEvidenceFilters = { filename: '', sourceTaskId: '', evidenceType: '', evidenceDate: '' };
			}
		},
		sortExistingEvidence(key: string) {
			if (this.existingEvidenceSortKey === key) {
				this.existingEvidenceSortDir = this.existingEvidenceSortDir === 'asc' ? 'desc' : 'asc';
			} else {
				this.existingEvidenceSortKey = key;
				this.existingEvidenceSortDir = 'asc';
			}
		},
		openLinkEvidencePopup() {
			this.selectedLinkTask = null
			this.selectedExistingFiles = []
			this.selectedExistingLinks = []
			this.selectedExistingEvidences = []
			this.resetExistingEvidenceTable();
			this.linkEvidencePopup = true
			this.loadExistingFileOptions();
		},
		closeLinkEvidencePopup() {
			this.linkEvidencePopup = false
			this.selectedLinkTask = null
			this.selectedExistingFiles = []
			this.selectedExistingLinks = []
			this.selectedExistingEvidences = []
			this.resetExistingEvidenceTable();
		},
		onLinkTaskChange() {
			this.selectedExistingFiles = []
			this.selectedExistingLinks = []
			this.selectedExistingEvidences = []
		},
		syncSelectedExistingEvidences() {
			this.selectedExistingEvidences = [...this.selectedExistingFiles, ...this.selectedExistingLinks];
		},
		isExistingEvidenceSelected(row: any) {
			return (this.selectedExistingEvidences || []).some((item: any) => item.optionKey === row.optionKey);
		},
		toggleExistingEvidence(row: any) {
			const selected = [...(this.selectedExistingEvidences || [])];
			const index = selected.findIndex((item: any) => item.optionKey === row.optionKey);
			if (index >= 0) {
				selected.splice(index, 1);
			} else {
				selected.push(row);
			}
			this.selectedExistingEvidences = selected;
		},
		async saveLinkedEvidence() {
			const docs = this.selectedExistingEvidences || [];
			const evidences = docs.filter((doc: any) => doc?.url).map((doc: any) => {
				const filename = doc.filename || doc.name;
				const item: any = {
					url: doc.url,
					filename,
					evidenceDate: doc.evidenceDate,
					evidenceType: doc.evidenceType || 'file'
				};
				if (doc.fileType !== undefined && doc.fileType !== null) {
					item.fileType = doc.fileType;
				}
				if (doc.sourceTaskId != null && String(doc.sourceTaskId) !== '') {
					item.linkedEvidenceTaskId = String(doc.sourceTaskId);
				}
				return item;
			});
			if (!evidences.length) return;
			this.linkEvidencePopup = false;
			try {
				await this.updateTemplateTask(2, { evidences });
				this.resetEvidenceForm();
			} catch (err) {
				toast.error(`Error`, {
					timeout: 1000,
					closeOnClick: true,
					closeButton: 'button',
					icon: true
				});
				this.resetEvidenceForm();
			}
		},
		onEvidenceSave() {
			this.handleFileChange();
		},
		updateFileName(event: any) {
			let file = this.$refs.fileInput.files[0];

			if (file && !file.type.match('application/pdf') && !file.name.endsWith('.doc') && !file.name.endsWith('.docx')) {
				alert('Please select a PDF, DOC, or DOCX file.');
				return;
			} else {
				this.fileChanged = true;
				this.fileToUpload.file = file;
			}
		},
		resetEvidenceForm() {
			this.inputFileName = ''
			this.fileName = ''
			this.evidenceDate = ''
			this.fileToUpload = null
			this.evidenceUrl = ''
			this.evidenceAttachMode = 'file'
			this.selectedExistingFiles = []
			this.selectedExistingLinks = []
			this.selectedExistingEvidences = []
			this.selectedLinkTask = null
			this.v$.$reset();
		},
		async handleUrlEvidenceSave() {
			this.v$.inputFileName.$touch()
			this.v$.evidenceUrl.$touch()
			this.v$.evidenceDate.$touch()
			if (this.v$.inputFileName.$invalid || this.v$.evidenceUrl.$invalid || this.v$.evidenceDate.$invalid) {
				return;
			}
			this.importpopUp = false
			try {
				const payload: any = {
					url: this.evidenceUrl,
					filename: this.inputFileName,
					evidenceDate: new Date(this.evidenceDate).toISOString(),
					evidenceType: 'url'
				};
				await this.updateTemplateTask(2, payload);
				this.resetEvidenceForm();
			} catch (err) {
				toast.error(`Error`, {
					timeout: 1000,
					closeOnClick: true,
					closeButton: 'button',
					icon: true
				});
				this.resetEvidenceForm();
			} finally {
				this.clickOnButton = false;
			}
		},
		async handleFileChange(event: any) {
			if (this.evidenceAttachMode === 'url') {
				await this.handleUrlEvidenceSave();
				return;
			}

			  let data = this.fileToUpload;
			
			this.v$.inputFileName.$touch()
			this.v$.fileToUpload.$touch()
			this.v$.evidenceDate.$touch()
			if((!this.v$.fileToUpload.$invalid) && (!this.v$.inputFileName.$invalid) && (!this.v$.evidenceDate.$invalid)){
				this.importpopUp = !this.importpopUp
				let fileExtension = data.name.split('.').pop();

				if (fileExtension == 'pdf' || fileExtension == 'docx' || fileExtension == 'xls' || fileExtension == 'xlsx' || fileExtension == 'jpeg'|| fileExtension == 'png'|| fileExtension == 'jpg' || fileExtension == 'mp4'|| fileExtension == 'doc' || fileExtension == 'rtf' || fileExtension == 'txt' || fileExtension == 'csv' || fileExtension=='zip' || fileExtension == 'ods') {
					const fileDataFormat = await this.getConvertDataForFile(data);
					
					let uuid = uuidv4();
					let payload = { fileData: fileDataFormat,fileType:1, name: `${uuid}.${fileExtension}` };
					let folderName = `${process.env.VUE_APP_PLANNER_FOLDER_NAME}`;
					try {
						await this.$http
							.post(`${process.env.VUE_APP_FILE_API}/bucket/${folderName}/file/upload`, payload)
							.then(async (response: any) => {
								if (response.status == 200) {
									let payload: any = {
										// name: `${uuid}.${fileExtension}`,
										url: response.data,
										filename:this.inputFileName,
										evidenceDate: new Date(this.evidenceDate).toISOString(),
										fileType:1,
										evidenceType: 'file'
									};
									await this.updateTemplateTask(2, payload);
									this.resetEvidenceForm();
								} else {
									// console.log('response status', response.status);
								}
							});
					} catch (err) {
						toast.error(`Error`, {
							timeout: 1000,
							closeOnClick: true,
							closeButton: 'button',
							icon: true
						});
						this.resetEvidenceForm();
					} finally {
						this.clickOnButton = false;
					}
				} else {
					toast.error(`Upload only pdf`, {
						timeout: 1000,
						closeOnClick: true,
						closeButton: 'button',
						icon: true
					});
					this.v$.$reset();
				}
				
				this.fileName = '';
				this.inputFileName = '';
				this.fileToUpload=null
			}
		},
		async getConvertDataForFile(data: any) {
			return new Promise((resolve) => {
				const reader: any = new FileReader();
				reader.onload = function () {
					// resolve(reader.result.replace('data:', '').replace(/^.+,/, ''));
					// const result = reader.result as string;
					// const base64 = result.includes(',') ? result.split(',')[1] : result;
					resolve(reader.result);
				};
				reader.readAsDataURL(data);
			});
		},
		
		setBreadcrumbs() {
			const subtaskLabel = this.presentSubTask?.taskId || 'N/A';
			if (this.$route.query.tasks == 'true' || this.currentParentTaskId) {
				const parentLabel = this.presentTemplateTask?.taskId || 'N/A';
				this.routesArray = [
					{ name: 'Task', routeName: 'tasks' },
					{ name: parentLabel, routeName: 'templateTaskEdit' },
					{ name: subtaskLabel, routeName: 'subTaskEdit' },
				];
			} else {
				this.routesArray = [
					{ name: 'Task', routeName: 'tasks' },
					{ name: subtaskLabel, routeName: 'subTaskEdit' },
				];
			}
		},
		emitHeaderInfo() {
			if (!this.modalMode) {
				return;
			}
			this.$emit('header-info', {
				id: this.presentSubTask?.taskId || '',
				title: this.presentSubTask?.TaskName || this.presentSubTask?.mainTaskName || '',
			});
		},
		resolveControlTitle() {
			if (this.presentSubTask?.control && this.allActiveControls?.length) {
				this.controltitle = this.allActiveControls.find((obj: any) => obj._id == this.presentSubTask.control);
			}
		},
		async getPresentSubTask() {
			this.dotsLoader = true
            let subtaskId:any = this.currentSubtaskId
			try {
				const res: any = await this.$http.get(`${process.env.VUE_APP_PLANNER_API}/api/org/task/${subtaskId}/get`);
				this.presentSubTask = res.data;

				this.resolveControlTitle();

				this.teamName = this.teamObject.find((obj: any)=>{return obj.value == this.presentSubTask.team})

				this.TaskDetailsDropDown.taskStatus = this.presentSubTask.statusCode;

				if(this.presentSubTask.assignee != undefined){
					let userObj:any = this.optionsUserArray.find((obj:any)=>{return obj.value == this.presentSubTask.assignee});
					this.presentSubTask.assignee = userObj;
				}else{
					let userObj:any = this.optionsUserArray.find((obj:any)=>{return obj.value == this.presentSubTask.auditor});
					this.presentSubTask.assignee = userObj;
				}
				this.dummyPresentSubTask = {...this.presentSubTask};
				if(this.presentSubTask !=undefined && this.presentSubTask.completedAt!='' && typeof this.presentSubTask.completedAt=='string'){
					this.presentSubTask.completedAt = moment(this.presentSubTask.completedAt).format('YYYY-MM-DD')
				}
				if(this.presentSubTask.startDate!=undefined && this.presentSubTask.startDate!=''){
					this.presentSubTask.startDate=moment(this.presentSubTask.startDate).format('YYYY-MM-DD')
				}
				if(this.presentSubTask.dueDate!=undefined && this.presentSubTask.dueDate!=''){
					this.presentSubTask.dueDate=moment(this.presentSubTask.dueDate).format('YYYY-MM-DD')
				}
				this.emitHeaderInfo();
			} catch (error: any) {
				toast.error(`Failed to load task`, {
					timeout: 1000,
					closeOnClick: true,
					closeButton: 'button',
					icon: true
				});
			} finally {
				this.dotsLoader = false
			}
        },
		async getSingleActiveControl(){
			let controlId = this.presentSubTask?.control|| this.presentSubTask?.controlId;
			await this.$http
			.get(`${process.env.VUE_APP_CONTROLS_API}/api/org/active/control/${controlId}/get`)
			.then((result: { data: any }) => {
				this.linkedControlDetails = result.data;	
			}).catch((error: any) => {
				toast.error(` ${error}`, {
					timeout: 1000,
					closeOnClick: true,
					closeButton: 'button',
					icon: true
				});
			});
        },
		async updateTemplateTask(type: any, payload: any,dateType:any) {
			payload.createdBy = this.userInfo._id;
			payload.updatedAt=new Date();
			payload.updatedBy = this.userInfo._id;
			payload.additionalInfo = [];
            let now = new Date();

			if(type == 2){
				if (Array.isArray(payload.evidences)) {
					const taskIdValue = this.presentSubTask?.taskId;
					payload.evidences.forEach((item: any) => {
						item.createdBy = payload.createdBy;
						item.updatedAt = payload.updatedAt;
						item.updatedBy = payload.updatedBy;
						item.taskId = taskIdValue;
						item.additionalInfo = { evidence: item.filename, evidenceDate: item.evidenceDate };
						item.fileType = item.fileType;
					});
				} else {
				payload.taskId =this.presentSubTask?.taskId
				payload.additionalInfo = {evidence:'',evidenceDate:''};
				payload.additionalInfo.evidence = payload.filename;
				payload.additionalInfo.evidenceDate = payload.evidenceDate;
				payload.fileType = payload.fileType
				}
			} else if(type == 3){
				payload.additionalInfo = {approver:''};
				payload.additionalInfo.approver = payload.approver;
			} else if(type == 4){
				payload.additionalInfo = {comment:''};
				payload.additionalInfo.comment = payload.comment;
			} else if(type == 5){
				payload.additionalInfo = {previousStatus:'',updatedStatus:''};
				payload.additionalInfo.previousStatus = this.presentSubTask.statusCode;
				payload.additionalInfo.updatedStatus = payload.statusCode;
				if(payload.justification){
					payload.additionalInfo.justification = payload.justification;
				}
				if(this.presentSubTask.hasOwnProperty('isActiveControlTask') && this.presentSubTask.isActiveControlTask == true){
					payload.dueDate = moment(new Date());
				}				
			} else if(type == 6){
				payload.additionalInfo = {assignee:''};
				payload.additionalInfo.assignee = payload.assignee;
			} else if(type == 7){
				payload.additionalInfo = {createdBy:''};
				payload.additionalInfo.createdBy = payload.createdBy;
			} else if(type == 8){
				if (dateType == 20604) {
                    let selectedStartDate = new Date(this.dummySubTask.startDate);
					selectedStartDate.setHours(
						now.getHours(),
						now.getMinutes(),
						now.getSeconds(),
						now.getMilliseconds()
					);
                    payload.additionalInfo.push({
                        previousStartDate: selectedStartDate,
                        updatedStartDate: payload.startDate,
                        dateId: 20604
                    });
                }
				if(payload.completedAt && payload.completedAt!='') {
					let now = new Date();
					payload.completedAt = new Date(payload.completedAt);
					payload.completedAt.setHours(
						now.getHours(),
						now.getMinutes(),
						now.getSeconds(),
						now.getMilliseconds()
					);
					if(this.dummyPresentSubTask.completedAt && this.dummyPresentSubTask.completedAt!=''){
						this.dummyPresentSubTask.completedAt = new Date(this.dummyPresentSubTask.completedAt);
					this.dummyPresentSubTask.completedAt.setHours(
						now.getHours(),
						now.getMinutes(),
						now.getSeconds(),
						now.getMilliseconds()
					);
					}
					
					payload.updatedAt = new Date().toISOString();				
					// this.dummyPresentSubTask.completedAt =  new Date(this.dummyPresentSubTask.completedAt)
					payload.updatedBy = this.userInfo._id;
					delete payload.createdBy;
					let additionalInfoArr:any=[];
					let additionalInfo:any={};
					additionalInfo.previousCompletionDate = this.dummyPresentSubTask.completedAt,
					additionalInfo.updatedCompletionDate = payload.completedAt
					additionalInfo.dateId = 20606
					additionalInfoArr.push(additionalInfo);
					payload.additionalInfo = additionalInfoArr
				}
				if (dateType == 20605) {
                    let selectedEndDate = new Date(this.dummySubTask.dueDate);
                    selectedEndDate.setHours(
                        now.getHours(),
                        now.getMinutes(),
                        now.getSeconds(),
                        now.getMilliseconds()
                    );
                    payload.additionalInfo.push({
                        previousEndDate: selectedEndDate,
                        updatedEndDate: payload.endDate,
                        dateId: 20605
                    });
                }
			}
			try {	
				// if (this.presentSubTask!=undefined &&this.presentSubTask!=''&&this.presentSubTask.startDate!=undefined&&this.presentSubTask.startDate&&
				// 	this.presentSubTask.dueDate==this.presentSubTask.startDate
				
				// ) {
				// 	toast.error(`Start date and Due date cannot be the same`, {
				// 			timeout: 1000,
				// 			closeOnClick: true,
				// 			closeButton: 'button',
				// 			icon: true
				// 		});
				// }
				// else{
					if(this.presentSubTask!=undefined && (!this.presentSubTask.hasOwnProperty('linkedRiskId')  && payload.additionalInfo.updatedStatus!=10423|| (type!=5 || this.presentSubTask.treatmentType==10405 || this.presentSubTask.riskMitigation==true))) {						
						let result = await this.$http.post(`${process.env.VUE_APP_PLANNER_API}/api/org/task/${this.currentSubtaskId}/type/${type}/update`, payload).then(async (result: any) => {
						if(result.status==200 && payload.additionalInfo.updatedStatus==10403){
							if(this.presentSubTask?.mainTaskId!=undefined){
							await this.getMainTemplateTask(this.presentSubTask.mainTaskId);
							}
							if((this.mainTemplateTask!=undefined && this.mainTemplateTask.statusCode==10403)|| this.presentSubTask.actionType!=20502){
								let payload:any;								
								if(this.mainTemplateTask!=''){
									payload={taskId:this.mainTemplateTask._id};
								}
								else{									
									payload={taskId:this.currentSubtaskId};
								}
								try{
								await this.$http.post(`${process.env.VUE_APP_WORKFLOW_API}/api/org/trigger/workflow/${process.env.VUE_APP_CR_WORKFLOW_ID}/compliance/crTask`, payload).then(async (result: any) => {
									toast.info(`Updated`, {
										timeout: 1000,
										closeOnClick: true,
										closeButton: 'button',
										icon: true
									});
								});
								}
								catch{
									toast.error(`Error`, {
										timeout: 1000,
										closeOnClick: true,
										closeButton: 'button',
										icon: true
									});
								}
						 	}
						}
						else{
							toast.info(`Updated`, {
									timeout: 1000,
									closeOnClick: true,
									closeButton: 'button',
									icon: true
								});
						}
					});
					}
					if(this.presentSubTask!=undefined && this.presentSubTask.hasOwnProperty('linkedRiskId') && type == 5 && this.presentSubTask.treatmentType!=10405){
						let result = await this.$http.post(`${process.env.VUE_APP_WORKFLOW_API}/api/org/trigger/workflow/${process.env.VUE_APP_RISK_WORKFLOW_ACTION_ID}/task/${this.currentSubtaskId}/update`, payload).then(async (result: any) => {
							
							if(result.status==200 && payload.additionalInfo.updatedStatus==10423){
								let payload={taskId:this.currentSubtaskId};
								try{
								await this.$http.post(`${process.env.VUE_APP_WORKFLOW_API}/api/org/trigger/workflow/${process.env.VUE_APP_CR_WORKFLOW_ID}/compliance/crTask`, payload).then(async (result: any) => {
									toast.info(`Task Created`, {
										timeout: 1000,
										closeOnClick: true,
										closeButton: 'button',
										icon: true
									});
								});
								}
								catch{
									toast.error(`Error`, {
										timeout: 1000,
										closeOnClick: true,
										closeButton: 'button',
										icon: true
									});
								}
							}
							else if(result.status==200 && payload.additionalInfo.updatedStatus==10410){
								toast.error(`Rejected`, {
										timeout: 1000,
										closeOnClick: true,
										closeButton: 'button',
										icon: true
									});
							}
							else{
								toast.info(`Updated`, {
										timeout: 1000,
										closeOnClick: true,
										closeButton: 'button',
										icon: true
									});
							}
						})
					}
					
				// }
            } catch(error:any) {
				if(error.response && error.response.status==403) {
                            toast.error(`${error.response.data.error}`, {
                            timeout: 1000,
                            closeOnClick: true,
                            closeButton: 'button',
                            icon: true
                        });
                }
				else{
					toast.error(`Error`, {
						timeout: 1000,
						closeOnClick: true,
						closeButton: 'button',
						icon: true
                	});	
				}
            }
			await this.getPresentSubTask();
			await this.getSubTaskHistoryObject();
			// this.workLogObject.taskHistory?.sort().reverse();
		},
		colorTemplateText(status: any) {
			if (status == 10411) {
				return ['font-semibold text-xs text-disabledgrey'];
			} else if (status == 10415 || status == 10421) {
				return ['font-semibold text-xs text-yellow'];
			} else if (status == 10403 || status == 10423) {
				return ['font-semibold text-xs text-lightgreen'];
			} else if(status == 10402){
				return ['font-semibold text-xs mx-2 text-electricGreen']
			} else if(status == 10420 || status == 10410){
				return ['font-semibold text-xs mx-2 text-darkred']
			} else if(status == 10401){
				return ['font-semibold text-xs mx-2 text-primary']
			} else if(status == 10418){
				return ['font-semibold text-xs mx-2 text-error']
			}else{
				return 'N/A'
			}
		},
		colorTemplateBg(status: any) {
			if (status == 10411) {
				return ['bg-lightgrey border-solid border border-disabledgrey'];
			} else if (status == 10415 || status == 10421) {
				return ['bg-moderateColor border-solid border border-yellow'];
			} else if (status == 10403 || status == 10423) {
				return ['bg-veryLowColor border-solid border border-lightgreen'];
			} else if (status == 10402) {
				return ['pendingEvidence border-solid border border-electricGreen'];
			} else if (status == 10401) {
				return ['bg-primaryBg border-solid border border-primary'];
			} else if (status == 10420 || status == 10410) {
				return ['bg-veryHighColor border-solid border border-darkred'];
			} else if(status == 10418) {
				return 'bg-highColor border-solid border border-error';
			}
		},
		getControlFrequency(id: any) {
			if (id !== undefined && id !== '' && id !== null) {
				let frequency: any = this.dbFrequency.find((data: any) => {return data.value == id});
				if (frequency && frequency.key !== undefined) {
					return frequency.key;
				} else {
					return 'N/A';
				}
			} else {
				return 'N/A';
			}
		},
		async getPresentTemplateTask() {
			let taskId : any = this.currentParentTaskId
			if (!taskId) {
				return;
			}
			try {
				const res: any = await this.$http.get(`${process.env.VUE_APP_PLANNER_API}/api/org/task/${taskId}/get`);
				this.presentTemplateTask = res.data;
			} catch (error: any) {
				toast.error(`Failed to load parent task`, {
					timeout: 1000,
					closeOnClick: true,
					closeButton: 'button',
					icon: true
				});
				throw error;
			}
        },
		async getMainTemplateTask(task:any) {
			let taskId : any = task
			
            await this.$http.get(`${process.env.VUE_APP_PLANNER_API}/api/org/task/${taskId}/get`).then((res: any) => {
                this.mainTemplateTask = res.data;
            });
        },
		async getTaskStatuses(){
			let appId='10007';
			let entityId='10117';
			await this.$http.get(`${process.env.VUE_APP_AUTH_API}/${appId}/${entityId}/statuses`).then((result: any) => {	
				if(this.presentSubTask!=undefined && this.presentSubTask.hasOwnProperty('linkedRiskId') && (this.presentSubTask.treatmentType!=10405)){
                	this.statuses = result.data.riskTaskStatuses
					this.taskStatuses = result.data.riskTaskStatuses.filter((status:any)=>status.id==10401 || status.id==10402);
					this.subTaskStatuses = result.data.riskTaskStatuses.filter((status:any)=>status.id==10402 || status.id==10423 || status.id ==10410);
					this.treatmentTypeStatus=result.data.treatmentTypes
				}
				else{					
					this.statuses = result.data.taskStatus
					this.taskStatuses = result.data.taskStatus.filter((status:any)=>status.id==10401 || status.id==10402);
					this.subTaskStatuses = result.data.taskStatus.filter((status:any)=>status.id==10402 || status.id==10403);
					this.treatmentTypeStatus=result.data.treatmentTypes
				}				
			});
		}
	},
	async mounted(){
		emitter.off('addedComments');
		emitter.on('addedComments',(data: any)=>{
			this.comment = data.comments
			this.addComment()
		})
		window.addEventListener('resize', this.clampLinkWidthsToContainer);
	},
	async created(){
		this.dotsLoader = true;
		try {
			await this.getAllActiveUsers();
			await this.getPresentSubTask();
			this.setBreadcrumbs();

			if (this.$route.query.tasks == 'true' || this.currentParentTaskId) {
				try {
					await this.getPresentTemplateTask();
				} catch {
					// parent task fetch failed; breadcrumbs already have route-param fallback
				}
				this.setBreadcrumbs();
			}

			await Promise.allSettled([
				this.getTaskStatuses(),
				this.getAllTeams(),
				this.getallEntities(),
				this.getAllSystems(),
				this.fetchActivitiesList(),
				this.getAllProjects(),
				this.getAllBusinessProcesses(),
				this.getAllActiveControls(),
			]);

			this.resolveControlTitle();

			if (this.presentSubTask != undefined && this.presentSubTask.appId != 10003 || (this.presentSubTask?.hasOwnProperty('control') && this.presentSubTask?.treatmentType == 10405)) {
				await this.getSingleActiveControl();
			}

			if (this.presentSubTask) {
				this.dummySubTask = { ...this.presentSubTask };
			}

			await Promise.allSettled([this.getSubTaskHistoryObject()]);

			const savedTabKey = sessionStorage.getItem('selectedTab');
			if (savedTabKey) {
				const savedTab = this.tabHead.find((tab: any) => tab.id == savedTabKey);
				if (savedTab) {
					await this.toggleTabs(savedTab);
				} else {
					this.selectedTabObj = { displayName: 'Description', id: 1 };
					this.selectedTabIndex = 1;
				}
			} else {
				this.selectedTabObj = { displayName: 'Description', id: 1 };
				this.selectedTabIndex = 1;
			}

			if (this.presentSubTask?.comments != undefined) {
				this.presentSubTask.comments.sort().reverse();
			}

			this.titleLength = this.presentSubTask?.TaskName ? this.presentSubTask.TaskName.length : 0;
			this.controlTitleLength = this.controltitle?.controlTitle ? this.controltitle?.controlTitle.length : 0;
		} finally {
			this.dotsLoader = false;
		}
	},
	beforeUnmount() {
		this.stopLinkColumnResize();
		window.removeEventListener('resize', this.clampLinkWidthsToContainer);
		sessionStorage.removeItem('selectedTab')
	},
	
});
</script>
